import _toConsumableArray from "/home/haulmont/buildAgent/work/c816f139c3702443/modules/front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/haulmont/buildAgent/work/c816f139c3702443/modules/front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _possibleConstructorReturn from "/home/haulmont/buildAgent/work/c816f139c3702443/modules/front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/haulmont/buildAgent/work/c816f139c3702443/modules/front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/haulmont/buildAgent/work/c816f139c3702443/modules/front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _classCallCheck from "/home/haulmont/buildAgent/work/c816f139c3702443/modules/front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/haulmont/buildAgent/work/c816f139c3702443/modules/front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import React__default, { createElement, createContext, Component, Fragment } from 'react';
import { observable, action, ObservableMap, autorun, computed, reaction, toJS, runInAction } from 'mobx';
import { CubaApp, PredefinedView } from '@cuba-platform/rest';
import { inject, observer, Provider } from 'mobx-react';
import moment__default, { locale } from 'moment';
import { ConfigProvider, message, Upload, Icon, Select, Input, Checkbox, DatePicker, TimePicker, Form, Button, Tag, InputNumber, Tooltip, Radio, Spin, Divider, Table } from 'antd';
import { IntlProvider, injectIntl, FormattedMessage } from 'react-intl';

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var model = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var PermissionType;

  (function (PermissionType) {
    PermissionType["SCREEN"] = "SCREEN";
    PermissionType["ENTITY_OP"] = "ENTITY_OP";
    PermissionType["ENTITY_ATTR"] = "ENTITY_ATTR";
    PermissionType["SPECIFIC"] = "SPECIFIC";
    PermissionType["UI"] = "UI";
  })(PermissionType = exports.PermissionType || (exports.PermissionType = {}));

  var RoleType;

  (function (RoleType) {
    RoleType["STANDARD"] = "STANDARD";
    RoleType["SUPER"] = "SUPER";
    RoleType["READONLY"] = "READONLY";
    RoleType["DENYING"] = "DENYING";
    RoleType["STRICTLY_DENYING"] = "STRICTLY_DENYING";
  })(RoleType = exports.RoleType || (exports.RoleType = {}));

  var PredefinedView;

  (function (PredefinedView) {
    PredefinedView["MINIMAL"] = "_minimal";
    PredefinedView["LOCAL"] = "_local";
    PredefinedView["BASE"] = "_base";
  })(PredefinedView = exports.PredefinedView || (exports.PredefinedView = {}));
});
unwrapExports(model);
var model_1 = model.PermissionType;
var model_2 = model.RoleType;
var model_3 = model.PredefinedView;
var security = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   *
   * Define which type of attribute render allowed for user
   *
   * @param entityName CUBA model entity
   * @param attributeName
   * @param perms - list of user permissions
   * @param roles - list of user roles
   * @return attribute could be not allowed to display (DENY), allowed for modification (MODIFY)
   * or allowed in read only mode (VIEW).
   */

  function getAttributePermission(entityName, attributeName, perms, roles) {
    if (!perms || !roles) return 'DENY';

    if (hasRole(roles, model.RoleType.SUPER)) {
      return 'MODIFY';
    }

    var perm = getMaxAllowedAttrPerm(entityName, attributeName, perms); // return 'DENY' if no permission exist and user in STRICTLY_DENYING role

    if (hasRole(roles, model.RoleType.STRICTLY_DENYING) && perm === null) {
      return 'DENY';
    }

    return perm == null ? 'MODIFY' : perm.value;
  }

  exports.getAttributePermission = getAttributePermission;
  /**
   * Define if operation (one of CRUD) on entity allowed or not for user
   *
   * @param entityName CUBA model entity
   * @param operation - operation to be checked (CRUD)
   * @param perms - list of user permissions
   * @param roles - list of user roles
   */

  function isOperationAllowed(entityName, operation, perms, roles) {
    if (!perms || !roles) return false;
    if (hasRole(roles, model.RoleType.SUPER)) return true;
    var perm = getMaxAllowedOpPerm(entityName, operation, perms); // readonly role not affect read operation

    if (hasRole(roles, model.RoleType.READONLY) && operation !== 'read') {
      // operation (except read) is disabled for readonly role if no perm is set
      if (perm == null) return false;
    }

    if (hasRole(roles, model.RoleType.DENYING) || hasRole(roles, model.RoleType.STRICTLY_DENYING)) {
      // operation is disabled for denying roles if no perm is set
      if (perm == null) return false;
    }

    return perm == null || perm.value !== 'DENY' ? true : false;
  }

  exports.isOperationAllowed = isOperationAllowed;

  function getMaxAllowedOpPerm(entityName, operation, perms) {
    var opFqn = entityName + ":" + operation;
    return perms.filter(function (perm) {
      return perm.type === model.PermissionType.ENTITY_OP && perm.target === opFqn;
    }).reduce(function (resultPerm, perm) {
      // assign result perm to maximum allowed permission between current and resultPerm
      if (resultPerm == null) return perm;
      if (perm.value === 'ALLOW') return perm;
      return resultPerm;
    }, null);
  }

  function getMaxAllowedAttrPerm(entityName, attributeName, perms) {
    var attrFqn = entityName + ":" + attributeName;
    return perms.filter(function (perm) {
      return perm.type === model.PermissionType.ENTITY_ATTR && perm.target === attrFqn;
    }).reduce(function (resultPerm, perm) {
      if (resultPerm === null) return perm; // assign result perm to maximum allowed permission between current and resultPerm

      var resultPermValue = resultPerm.value;
      var currentPermValue = perm.value;
      if (currentPermValue === 'MODIFY') return perm;
      if (currentPermValue === 'VIEW' && resultPermValue === 'DENY') return perm;
      return resultPerm;
    }, null);
  }

  function hasRole(roles, roleType) {
    return roles.some(function (r) {
      return r.roleType === roleType;
    });
  }
});
unwrapExports(security);
var security_1 = security.getAttributePermission;
var security_2 = security.isOperationAllowed;

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var Security =
/*#__PURE__*/
function () {
  function Security(cubaREST) {
    var _this = this;

    _classCallCheck(this, Security);

    this.cubaREST = cubaREST;
    this.attrPermissionCache = new ObservableMap();
    this.permissionsRequestCount = 0;

    this.getAttributePermission = function (entityName, attributeName) {
      // do not check permissions if roles not set (rest api version prev 7.2)
      if (!_this.roles) return 'MODIFY';
      var attrFqn = "".concat(entityName, ":").concat(attributeName);

      var perm = _this.attrPermissionCache.get(attrFqn);

      if (perm != null) return perm;
      perm = security_1(entityName, attributeName, _this.permissions, _this.roles);

      _this.attrPermissionCache.set(attrFqn, perm);

      return perm;
    };
  }

  _createClass(Security, [{
    key: "loadPermissions",
    value: function loadPermissions() {
      var _this2 = this;

      var requestId = ++this.permissionsRequestCount;
      this.cubaREST.getPermissions().then(action(function (perms) {
        if (requestId === _this2.permissionsRequestCount) {
          _this2.permissions = observable(perms);
        }
      }));
    }
  }]);

  return Security;
}();

__decorate([observable], Security.prototype, "permissions", void 0);

__decorate([observable], Security.prototype, "attrPermissionCache", void 0);

__decorate([observable], Security.prototype, "roles", void 0);

__decorate([action], Security.prototype, "loadPermissions", null);

var __decorate$1 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var MainStore =
/*#__PURE__*/
function () {
  function MainStore(cubaREST) {
    var _this3 = this;

    _classCallCheck(this, MainStore);

    this.cubaREST = cubaREST;
    this.initialized = false;
    this.authenticated = false;
    this.usingAnonymously = false;
    this.metadataRequestCount = 0;
    this.messagesRequestCount = 0;
    this.enumsRequestCount = 0;

    this.setLocale = function (locale) {
      _this3.cubaREST.locale = locale;
    };

    this.handleLocaleChange = function (locale$1) {
      _this3.locale = locale$1; // We need to set locale for moment since antd uses moment's localized messages in e.g. Calendar or DatePicker

      locale(locale$1);

      if (_this3.initialized && (_this3.authenticated || _this3.usingAnonymously)) {
        _this3.loadEnums();

        _this3.loadMessages();
      }

      if (_this3.initialized && _this3.authenticated) {
        _this3.setSessionLocale();
      }
    };

    this.setSessionLocale = function () {
      _this3.cubaREST.setSessionLocale().catch(function (reason) {
        if (reason === CubaApp.NOT_SUPPORTED_BY_API_VERSION) {
          console.warn('Relogin is required in order for bean validation messages to use correct locale. ' + 'Upgrade to REST API 7.2.0 or higher to be able to change locale without relogin.');
        } else {
          throw new Error('Failed to set session locale');
        }
      });
    };

    this.cubaREST.onLocaleChange(this.handleLocaleChange);
    this.security = new Security(this.cubaREST);
    autorun(function () {
      if (_this3.initialized && (_this3.authenticated || _this3.usingAnonymously)) {
        _this3.security.loadPermissions();

        _this3.loadEnums();

        _this3.loadMetadata();

        _this3.loadMessages();
      }
    });
  }

  _createClass(MainStore, [{
    key: "loadEnums",
    value: function loadEnums() {
      var _this4 = this;

      var requestId = ++this.enumsRequestCount;
      this.cubaREST.loadEnums().then(action(function (enums) {
        if (requestId === _this4.enumsRequestCount) {
          _this4.enums = observable(enums);
        }
      }));
    }
  }, {
    key: "loadMetadata",
    value: function loadMetadata() {
      var _this5 = this;

      var requestId = ++this.metadataRequestCount;
      this.cubaREST.loadMetadata().then(action(function (metadata) {
        if (requestId === _this5.metadataRequestCount) {
          _this5.metadata = observable(metadata);
        }
      }));
    }
  }, {
    key: "loadMessages",
    value: function loadMessages() {
      var _this6 = this;

      var requestId = ++this.messagesRequestCount;
      this.cubaREST.loadEntitiesMessages().then(action(function (res) {
        if (requestId === _this6.messagesRequestCount) {
          _this6.messages = res;
        }
      }));
    }
  }, {
    key: "login",
    value: function login(_login, password) {
      var _this7 = this;

      return this.cubaREST.login(_login, password).then(action(function () {
        _this7.userName = _login;
        _this7.authenticated = true;
      }));
    }
  }, {
    key: "logout",
    value: function logout() {
      var _this8 = this;

      if (this.usingAnonymously) {
        this.usingAnonymously = false;
        return Promise.resolve();
      }

      if (this.cubaREST.restApiToken != null) {
        return this.cubaREST.logout().then(action(function () {
          _this8.authenticated = false;
        }));
      }

      return Promise.resolve();
    }
  }, {
    key: "initialize",
    value: function initialize() {
      var _this9 = this;

      this.locale = this.cubaREST.locale;
      this.cubaREST.getUserInfo().then(action(function (userInfo) {
        if (_this9.cubaREST.restApiToken == null) {
          _this9.usingAnonymously = true;
        } else {
          _this9.authenticated = true;
        }

        _this9.userName = userInfo.name;
        _this9.initialized = true;
      })).catch(action(function () {
        _this9.initialized = true;
      }));
    }
  }, {
    key: "loginRequired",
    get: function get() {
      return !this.authenticated && !this.usingAnonymously;
    }
  }]);

  return MainStore;
}();

MainStore.NAME = 'mainStore';

__decorate$1([observable], MainStore.prototype, "initialized", void 0);

__decorate$1([observable], MainStore.prototype, "authenticated", void 0);

__decorate$1([observable], MainStore.prototype, "usingAnonymously", void 0);

__decorate$1([observable], MainStore.prototype, "userName", void 0);

__decorate$1([observable], MainStore.prototype, "locale", void 0);

__decorate$1([observable], MainStore.prototype, "metadata", void 0);

__decorate$1([observable], MainStore.prototype, "messages", void 0);

__decorate$1([observable], MainStore.prototype, "enums", void 0);

__decorate$1([action], MainStore.prototype, "loadEnums", null);

__decorate$1([action], MainStore.prototype, "loadMetadata", null);

__decorate$1([action], MainStore.prototype, "loadMessages", null);

__decorate$1([action], MainStore.prototype, "handleLocaleChange", void 0);

__decorate$1([computed], MainStore.prototype, "loginRequired", null);

__decorate$1([action], MainStore.prototype, "login", null);

__decorate$1([action], MainStore.prototype, "logout", null);

function injectMainStore(target) {
  return inject(MainStore.NAME)(target);
}

var I18nProvider = observer(function (_ref) {
  var messagesMapping = _ref.messagesMapping,
      antdLocaleMapping = _ref.antdLocaleMapping,
      mainStore = _ref.mainStore,
      children = _ref.children;
  return createElement(IntlProvider, {
    locale: mainStore.locale,
    messages: messagesMapping[mainStore.locale]
  }, createElement(ConfigProvider, {
    locale: antdLocaleMapping[mainStore.locale]
  }, children));
});
var cubaAppContext;
var globalCubaREST;
var mainStore;

function getCubaREST() {
  return globalCubaREST;
}

function getMainStore() {
  return mainStore;
}

var CubaAppProvider = function CubaAppProvider(_ref2) {
  var cubaREST = _ref2.cubaREST,
      messagesMapping = _ref2.messagesMapping,
      antdLocaleMapping = _ref2.antdLocaleMapping,
      children = _ref2.children;
  var CubaAppContext = getContext();
  return createElement(CubaAppContext.Consumer, null, function () {
    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (cubaREST && context.cubaREST !== cubaREST) {
      globalCubaREST = cubaREST;
      mainStore = new MainStore(cubaREST);
      mainStore.initialize();
      context = Object.assign({}, context, {
        cubaREST: cubaREST
      });
    }

    if (!context.cubaREST) {
      throw new Error("cubaREST instance is not passed");
    }

    return createElement(CubaAppContext.Provider, {
      value: context
    }, createElement(Provider, {
      mainStore: mainStore
    }, createElement(I18nProvider, {
      messagesMapping: messagesMapping,
      antdLocaleMapping: antdLocaleMapping,
      mainStore: mainStore
    }, children)));
  });
};

function getContext() {
  if (!cubaAppContext) {
    cubaAppContext = createContext({});
  }

  return cubaAppContext;
}

var menuItems = [];

function getMenuItems() {
  return menuItems;
}

var __decorate$2 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var DataContext =
/*#__PURE__*/
function () {
  function DataContext(containers) {
    var _this10 = this;

    _classCallCheck(this, DataContext);

    this.save = function () {
      var _loop = function _loop(containerName) {
        if (!_this10.containers.hasOwnProperty(containerName)) {
          return "continue";
        }

        var container = _this10.containers[containerName];
        container.changedItems.forEach(function (entity) {
          getCubaREST().commitEntity(container.entityName, entity);
        });
      };

      for (var containerName in _this10.containers) {
        var _ret = _loop(containerName);

        if (_ret === "continue") continue;
      }
    };

    this.containers = containers;
  }

  _createClass(DataContext, [{
    key: "hasChanges",
    get: function get() {
      if (!this.containers || Object.getOwnPropertyNames(this.containers).length < 1) {
        return false;
      }

      for (var containerName in this.containers) {
        if (!this.containers.hasOwnProperty(containerName)) {
          continue;
        }

        if (this.containers[containerName].changedItems != null && this.containers[containerName].changedItems.length > 0) {
          return true;
        }
      }

      return false;
    }
  }]);

  return DataContext;
}();

__decorate$2([observable], DataContext.prototype, "containers", void 0);

__decorate$2([action], DataContext.prototype, "save", void 0);

__decorate$2([computed], DataContext.prototype, "hasChanges", null);

function data(containers) {
  return new DataContext(containers);
}

var __decorate$3 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var DataCollectionStore =
/*#__PURE__*/
function () {
  function DataCollectionStore(entityName) {
    var _this11 = this;

    var trackChanges = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var viewName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PredefinedView.MINIMAL;
    var sort = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;

    _classCallCheck(this, DataCollectionStore);

    this.entityName = entityName;
    this.trackChanges = trackChanges;
    this.items = [];
    this.status = "CLEAN";
    this.changedItems = observable([]);

    this.load = function () {
      _this11.changedItems.clear();

      _this11.status = "LOADING";

      if (_this11.filter) {
        _this11.handleLoading(getCubaREST().searchEntitiesWithCount(_this11.entityName, _this11.filter, _this11.entitiesLoadOptions));
      } else {
        _this11.handleLoading(getCubaREST().loadEntitiesWithCount(_this11.entityName, _this11.entitiesLoadOptions));
      }
    };

    this.clear = function () {
      _this11.items = [];

      _this11.changedItems.clear();

      _this11.status = 'CLEAN';
    };

    this.delete = function (e) {
      if (e == null || e.id == null) {
        throw new Error('Unable to delete entity without ID');
      }

      _this11.status = 'LOADING';
      return getCubaREST().deleteEntity(_this11.entityName, e.id).then(action(function () {
        _this11.load();

        return true;
      })).catch(action(function () {
        _this11.status = "DONE";
        return true;
      }));
    };

    this.view = viewName;

    if (sort) {
      this.sort = sort;
    }

    if (this.trackChanges) {
      reaction(function () {
        return [_this11.items, _this11.items.length];
      }, function () {
        _this11.changedItems.push(_this11.items);
      });
    }
  }

  _createClass(DataCollectionStore, [{
    key: "handleLoading",
    value: function handleLoading(promise) {
      var _this12 = this;

      promise.then(function (resp) {
        runInAction(function () {
          _this12.items = resp.result;
          _this12.count = resp.count;
          _this12.status = 'DONE';
        });
      }).catch(function () {
        runInAction(function () {
          _this12.status = 'ERROR';
        });
      });
    }
  }, {
    key: "readOnlyItems",
    get: function get() {
      return toJS(this.items);
    }
  }, {
    key: "properties",
    get: function get() {
      return [];
    }
  }, {
    key: "entitiesLoadOptions",
    get: function get() {
      var loadOptions = {
        view: this.view
      };

      if (this.sort) {
        loadOptions.sort = this.sort;
      }

      if (this.limit !== null && this.limit !== undefined) {
        loadOptions.limit = this.limit;
      }

      if (this.offset !== null && this.offset !== undefined) {
        loadOptions.offset = this.offset;
      }

      return loadOptions;
    }
  }]);

  return DataCollectionStore;
}();

__decorate$3([observable], DataCollectionStore.prototype, "items", void 0);

__decorate$3([observable], DataCollectionStore.prototype, "status", void 0);

__decorate$3([observable], DataCollectionStore.prototype, "view", void 0);

__decorate$3([observable], DataCollectionStore.prototype, "sort", void 0);

__decorate$3([observable], DataCollectionStore.prototype, "filter", void 0);

__decorate$3([observable], DataCollectionStore.prototype, "limit", void 0);

__decorate$3([observable], DataCollectionStore.prototype, "offset", void 0);

__decorate$3([observable], DataCollectionStore.prototype, "count", void 0);

__decorate$3([action], DataCollectionStore.prototype, "load", void 0);

__decorate$3([action], DataCollectionStore.prototype, "clear", void 0);

__decorate$3([action], DataCollectionStore.prototype, "delete", void 0);

__decorate$3([computed], DataCollectionStore.prototype, "readOnlyItems", null);

__decorate$3([computed // todo
], DataCollectionStore.prototype, "properties", null);

var defaultOpts = {
  loadImmediately: true
};

function createStore(entityName, opts) {
  var dataCollection = new DataCollectionStore(entityName, !!opts.trackChanges);

  if (opts.view) {
    dataCollection.view = opts.view;
  }

  if (opts.filter) {
    dataCollection.filter = opts.filter;
  }

  if (opts.sort) {
    dataCollection.sort = opts.sort;
  }

  if (opts.limit !== null && opts.limit !== undefined) {
    dataCollection.limit = opts.limit;
  }

  if (opts.offset !== null && opts.offset !== undefined) {
    dataCollection.offset = opts.offset;
  }

  if (typeof opts.loadImmediately === 'undefined' || opts.loadImmediately) {
    dataCollection.load();
  }

  return dataCollection;
}

var withDataCollection = function withDataCollection(entityName) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOpts;
  return function (target) {
    return inject(function () {
      var dataCollection = createStore(entityName, opts);
      return {
        dataCollection: dataCollection
      };
    })(target);
  };
};

var collection = function collection(entityName) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOpts;
  return createStore(entityName, opts);
};

var Collection =
/*#__PURE__*/
function (_Component) {
  _inherits(Collection, _Component);

  function Collection(props) {
    var _this13;

    _classCallCheck(this, Collection);

    _this13 = _possibleConstructorReturn(this, _getPrototypeOf(Collection).call(this, props));
    _this13.store = createStore(_this13.props.entityName, _this13.props);

    _this13.store.load();

    return _this13;
  }

  _createClass(Collection, [{
    key: "render",
    value: function render() {
      if (!this.props.children) {
        return null;
      }

      return this.props.children(this.childrenProps);
    }
  }, {
    key: "childrenProps",
    get: function get() {
      var _this$store = this.store,
          items = _this$store.items,
          status = _this$store.status,
          load = _this$store.load,
          clear = _this$store.clear;
      return Object.assign({
        items: items,
        status: status,
        load: load,
        clear: clear
      });
    }
  }]);

  return Collection;
}(Component);

__decorate$3([observable], Collection.prototype, "store", void 0);

__decorate$3([computed], Collection.prototype, "childrenProps", null);

Collection = __decorate$3([observer], Collection);

function getPropertyInfo(metadata, entityName, propertyName) {
  var metaClass = metadata.find(function (mci) {
    return mci.entityName === entityName;
  });

  if (metaClass == null) {
    return null;
  }

  var propInfo = metaClass.properties.find(function (prop) {
    return prop.name === propertyName;
  });
  return propInfo || null;
}
/**
 * A non-nullable version of {@link getPropertyInfo}
 *
 * @param propertyName
 * @param entityName
 * @param metadata
 *
 * @throws `Error` when `propertyInfo` is `null`
 */


function getPropertyInfoNN(propertyName, entityName, metadata) {
  var propertyInfo = getPropertyInfo(metadata, entityName, propertyName);

  if (!propertyInfo) {
    throw new Error('Cannot find MetaPropertyInfo for property ' + propertyName);
  }

  return propertyInfo;
}

function getEnumCaption(enumValueName, propertyInfo, enums) {
  var enumInfo = enums.find(function (enumInfo) {
    return enumInfo.name === propertyInfo.type;
  });

  if (!enumInfo) {
    return undefined;
  }

  var enumValue = enumInfo.values.find(function (enumValue) {
    return enumValue.name === enumValueName;
  });

  if (!enumValue) {
    return undefined;
  }

  return enumValue.caption;
}
/**
 *
 * @param propertyName
 * @param entityName
 * @param messages
 *
 * @returns localized entity property caption
 */


function getPropertyCaption(propertyName, entityName, messages) {
  return messages[entityName + '.' + propertyName];
}

function isFileProperty(propertyInfo) {
  return propertyInfo.type === 'sys$FileDescriptor' && isRelationProperty(propertyInfo);
}

function isDateProperty(_ref3) {
  var type = _ref3.type;
  return type === 'date';
}

function isTimeProperty(_ref4) {
  var type = _ref4.type;
  return type === 'time';
}

function isDateTimeProperty(_ref5) {
  var type = _ref5.type;
  return type === 'dateTime';
}

function isRelationProperty(propertyInfo) {
  return propertyInfo.attributeType === 'ASSOCIATION' || propertyInfo.attributeType === 'COMPOSITION';
}

function isToOneRelation(_ref6) {
  var cardinality = _ref6.cardinality;
  return cardinality === "MANY_TO_ONE" || cardinality === "ONE_TO_ONE";
}

function isToManyRelation(_ref7) {
  var cardinality = _ref7.cardinality;
  return cardinality === "ONE_TO_MANY" || cardinality === "MANY_TO_MANY";
}

var defaultDateFormat = 'YYYY-MM-DD';
var defaultTimeFormat = 'HH:mm:ss';
var defaultDateTimeFormat = 'YYYY-MM-DD HH:mm:ss.SSS';

var __decorate$4 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var DataInstanceStore =
/*#__PURE__*/
function () {
  function DataInstanceStore(mainStore, entityName) {
    var _this14 = this;

    var viewName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PredefinedView.MINIMAL;

    _classCallCheck(this, DataInstanceStore);

    this.mainStore = mainStore;
    this.entityName = entityName;
    this.status = "CLEAN";
    this.changedItems = observable([]);

    this.load = function (id) {
      _this14.item = undefined;

      if (!id) {
        return;
      }

      _this14.status = "LOADING";
      getCubaREST().loadEntity(_this14.entityName, id, {
        view: _this14.viewName
      }).then(function (loadedEntity) {
        runInAction(function () {
          _this14.item = loadedEntity;
          _this14.status = "DONE";
        });
      }).catch(function () {
        runInAction(function () {
          _this14.status = "ERROR";
        });
      });
    };

    this.commit = function () {
      if (_this14.item == null) {
        return Promise.reject();
      }

      _this14.status = 'LOADING';
      return getCubaREST().commitEntity(_this14.entityName, toJS(_this14.item)).then(function (updatedEntity) {
        runInAction(function () {
          if (updatedEntity.id != null) {
            _this14.item.id = updatedEntity.id;
          }

          _this14.status = 'DONE';
        });
      }).catch(function (e) {
        _this14.status = 'ERROR';
        throw e;
      });
    };

    this.viewName = viewName;
  }

  _createClass(DataInstanceStore, [{
    key: "setItem",
    value: function setItem(item) {
      this.item = item;
      this.status = "DONE";
    }
  }, {
    key: "update",
    value: function update(entityPatch) {
      var _this15 = this;

      var metadata = toJS(this.mainStore.metadata);
      var normalizedPatch = Object.assign({}, entityPatch);
      Object.entries(entityPatch).forEach(function (_ref8) {
        var _ref9 = _slicedToArray(_ref8, 2),
            key = _ref9[0],
            value = _ref9[1];

        var propInfo = getPropertyInfo(metadata, _this15.entityName, key);

        if (propInfo && isToOneRelation(propInfo) && typeof value === 'string') {
          normalizedPatch[key] = {
            id: value
          };
        }

        if (propInfo && isToManyRelation(propInfo) && Array.isArray(value)) {
          normalizedPatch[key] = value.map(function (id) {
            return {
              id: id
            };
          });
        }

        if (propInfo && isDateProperty(propInfo) && moment__default.isMoment(value)) {
          normalizedPatch[key] = value.format(defaultDateFormat);
        }

        if (propInfo && isTimeProperty(propInfo) && moment__default.isMoment(value)) {
          normalizedPatch[key] = value.format(defaultTimeFormat);
        }

        if (propInfo && isDateTimeProperty(propInfo) && moment__default.isMoment(value)) {
          normalizedPatch[key] = value.format(defaultDateTimeFormat);
        }

        if (value === '' || value == null) {
          normalizedPatch[key] = null;
        }
      });
      Object.assign(this.item, normalizedPatch);
      return this.commit();
    }
  }, {
    key: "getFieldValues",
    value: function getFieldValues(properties) {
      var _this16 = this;

      var metadata = this.mainStore.metadata;

      if (this.item == null || metadata == null) {
        return {};
      }

      var entity = this.item ? toJS(this.item) : {};
      var entityFields = properties.reduce(function (fields, propertyName) {
        var propertyInfo = getPropertyInfo(toJS(metadata), _this16.entityName, propertyName);

        if (propertyInfo == null) {
          fields[propertyName] = entity[propertyName];
          return fields;
        }

        var type = propertyInfo.type;

        if (propertyInfo.attributeType === "ASSOCIATION" || propertyInfo.attributeType === "COMPOSITION") {
          if (entity[propertyName] == null) {
            fields[propertyName] = entity[propertyName];
            return fields;
          }

          if (isToOneRelation(propertyInfo)) {
            if (propertyInfo.type === 'sys$FileDescriptor') {
              fields[propertyName] = {
                id: entity[propertyName].id,
                name: entity[propertyName].name
              };
            } else {
              fields[propertyName] = entity[propertyName].id;
            }

            return fields;
          }

          if (isToManyRelation(propertyInfo)) {
            // @ts-ignore
            var entityList = entity[propertyName]; // @ts-ignore

            fields[propertyName] = entityList.reduce(function (accumulator, nextEntity) {
              accumulator.push(nextEntity.id);
              return accumulator;
            }, []);
            return fields;
          }
        }

        if (isTemporalType(type)) {
          if (entity[propertyName] == null) {
            fields[propertyName] = null;
          } else {
            fields[propertyName] = moment__default(entity[propertyName]);
          }

          return fields;
        } else {
          fields[propertyName] = entity[propertyName];
          return fields;
        }
      }, {});
      return entityFields;
    }
  }]);

  return DataInstanceStore;
}();

__decorate$4([observable], DataInstanceStore.prototype, "item", void 0);

__decorate$4([observable], DataInstanceStore.prototype, "status", void 0);

__decorate$4([observable], DataInstanceStore.prototype, "viewName", void 0);

__decorate$4([action], DataInstanceStore.prototype, "load", void 0);

__decorate$4([action], DataInstanceStore.prototype, "setItem", null);

__decorate$4([action], DataInstanceStore.prototype, "update", null);

__decorate$4([action], DataInstanceStore.prototype, "commit", void 0);

function instance(entityName, opts) {
  return new DataInstanceStore(getMainStore(), entityName, opts.view);
}

var withDataInstance = function withDataInstance(entityName) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    loadImmediately: true
  };
  return function (target) {
    return inject(function () {
      var dataInstance = new DataInstanceStore(getMainStore(), entityName, opts.view);
      return {
        dataInstance: dataInstance
      };
    })(target);
  };
};

var Instance =
/*#__PURE__*/
function (_Component2) {
  _inherits(Instance, _Component2);

  function Instance(props) {
    var _this17;

    _classCallCheck(this, Instance);

    _this17 = _possibleConstructorReturn(this, _getPrototypeOf(Instance).call(this, props));
    var _this17$props = _this17.props,
        entityName = _this17$props.entityName,
        view = _this17$props.view;
    _this17.store = new DataInstanceStore(getMainStore(), entityName);

    if (view != null) {
      _this17.store.viewName = view;
    }

    return _this17;
  }

  _createClass(Instance, [{
    key: "render",
    value: function render() {
      return this.props.children(this.childrenProps);
    }
  }, {
    key: "childrenProps",
    get: function get() {
      var _this$store2 = this.store,
          item = _this$store2.item,
          status = _this$store2.status,
          load = _this$store2.load,
          commit = _this$store2.commit;
      return Object.assign({
        item: item,
        status: status,
        load: load,
        commit: commit
      });
    }
  }]);

  return Instance;
}(Component);

__decorate$4([observable], Instance.prototype, "store", void 0);

__decorate$4([computed], Instance.prototype, "childrenProps", null);

Instance = __decorate$4([observer], Instance);

function isTemporalType(type) {
  return ["date", "time", "dateTime"].indexOf(type) > -1;
}

var EntityPropertyFormattedValue = observer(function (props) {
  var entityName = props.entityName,
      propertyName = props.propertyName,
      value = props.value,
      _props$showLabel = props.showLabel,
      showLabel = _props$showLabel === void 0 ? true : _props$showLabel,
      _props$hideIfEmpty = props.hideIfEmpty,
      hideIfEmpty = _props$hideIfEmpty === void 0 ? true : _props$hideIfEmpty,
      mainStore = props.mainStore;

  if (hideIfEmpty && value == null) {
    return null;
  }

  if (props.mainStore == null || props.mainStore.messages == null || !showLabel) {
    return createElement("div", null, formatValue(toJS(value)));
  } // store not ready yet


  if (!mainStore || !mainStore.messages || !mainStore.metadata || !mainStore.enums) {
    return null;
  }

  var label = props.mainStore.messages[entityName + '.' + propertyName];
  var propertyInfo = getPropertyInfo(props.mainStore.metadata, entityName, propertyName);

  if (!propertyInfo) {
    throw new Error('Cannot find MetaPropertyInfo for property ' + propertyName);
  }

  var displayValue = propertyInfo.attributeType === 'ENUM' ? getEnumCaption(value, propertyInfo, props.mainStore.enums) : toJS(value);
  return label != null ? createElement("div", null, createElement("strong", null, label, ":"), " ", formatValue(displayValue)) : createElement("div", null, formatValue(displayValue));
});
var EntityProperty = injectMainStore(observer(function (props) {
  return createElement(EntityPropertyFormattedValue, Object.assign({}, props));
}));

function formatValue(value) {
  var valType = typeof value;

  if (valType === "string") {
    return value;
  }

  if (valType === "object") {
    if (Object.prototype.hasOwnProperty.call(value, '_instanceName')) {
      return value._instanceName;
    }

    if (Array.isArray(value)) {
      var items = value.map(formatValue);
      return items.join(", ");
    }
  }

  return JSON.stringify(value);
}

var __decorate$5 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var FileUploadComponent =
/*#__PURE__*/
function (_Component3) {
  _inherits(FileUploadComponent, _Component3);

  function FileUploadComponent() {
    var _this18;

    _classCallCheck(this, FileUploadComponent);

    _this18 = _possibleConstructorReturn(this, _getPrototypeOf(FileUploadComponent).apply(this, arguments));
    _this18.fileList = [];
    _this18.reactionDisposers = [];

    _this18.handleChange = function (info) {
      var fileList = _toConsumableArray(info.fileList);

      fileList = fileList.slice(-1); // Limit to a single file

      if (info.file.status === 'error') {
        message.error(_this18.props.intl.formatMessage({
          id: 'cubaReact.fileUpload.uploadFailed'
        }));
      }

      if (info.file.status === 'done') {
        fileList[0].uid = info.file.response.id;
        fileList[0].url = '#';

        if (_this18.props.onChange) {
          _this18.props.onChange({
            id: info.file.response.id,
            name: info.file.response.name
          });
        }
      }

      _this18.fileList = _toConsumableArray(fileList);
    };

    _this18.handlePreview = function (_file) {
      getCubaREST().getFile(_this18.fileList[0].uid).then(function (blob) {
        var objectUrl = URL.createObjectURL(blob);
        var fileName = _this18.fileList[0].name;

        if (isImageFile(fileName)) {
          // Open image in a new tab
          window.open(objectUrl);
        } else {
          // Download file with correct filename
          var anchor = document.createElement('a');
          anchor.href = objectUrl;
          anchor.download = fileName;
          anchor.click();
        }

        URL.revokeObjectURL(objectUrl);
      });
    };

    _this18.handleRemove = function (_file) {
      _this18.fileList = [];

      if (_this18.props.onChange) {
        _this18.props.onChange(null);
      }
    };

    return _this18;
  }

  _createClass(FileUploadComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this19 = this;

      this.reactionDisposers.push(reaction(function () {
        return _this19.props.value;
      }, function () {
        if (_this19.props.value) {
          _this19.fileList = [{
            uid: _this19.props.value.id,
            name: _this19.props.value.name,
            size: 0,
            type: '',
            url: '#'
          }];
        }
      }));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.reactionDisposers.forEach(function (disposer) {
        return disposer();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var defaultUploadProps = {
        action: getCubaREST().getFileUploadURL(),
        headers: {
          'Authorization': 'Bearer ' + getCubaREST().restApiToken
        },
        fileList: this.fileList,
        onChange: this.handleChange,
        onPreview: this.handlePreview,
        onRemove: this.handleRemove,
        disabled: this.props.disabled,
        showUploadList: {
          showDownloadIcon: false,
          showPreviewIcon: true,
          showRemoveIcon: true
        },
        className: this.props.enableFullWidth ? '_cuba-file-upload-full-width-enabled' : ''
      };
      var uploadProps = Object.assign({}, defaultUploadProps, this.props.uploadProps);
      return createElement(Upload, Object.assign({}, uploadProps), this.props.render ? this.props.render(this.props.value) : createElement(FileUploadDropArea, {
        fileInfo: this.props.value
      }));
    }
  }]);

  return FileUploadComponent;
}(Component);

FileUploadComponent.defaultProps = {
  enableFullWidth: true
};

__decorate$5([observable], FileUploadComponent.prototype, "fileList", void 0);

FileUploadComponent = __decorate$5([observer], FileUploadComponent);

function FileUploadDropArea(props) {
  return props.fileInfo ? createElement("div", {
    className: 'cuba-file-drop-area'
  }, createElement(Icon, {
    className: 'replaceicon',
    type: 'upload'
  }), createElement("span", {
    className: 'replacetext'
  }, createElement(FormattedMessage, {
    id: 'cubaReact.fileUpload.replace'
  }))) : createElement("div", {
    className: 'cuba-file-drop-area'
  }, createElement(Icon, {
    className: 'uploadicon',
    type: 'upload'
  }), createElement("div", {
    className: 'uploadtext'
  }, createElement(FormattedMessage, {
    id: 'cubaReact.fileUpload.upload'
  })));
}

function isImageFile(fileName) {
  return !!fileName.match('.*(jpg|jpeg|gif|png)$');
}

var fileUpload = injectIntl(FileUploadComponent);

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var EntitySelectField = observer(function (props) {
  var optionsContainer = props.optionsContainer,
      rest = __rest(props, ["optionsContainer"]);

  return createElement(Select, Object.assign({}, rest, {
    loading: optionsContainer && optionsContainer.status === "LOADING"
  }), optionsContainer && optionsContainer.items.map(function (entity) {
    return createElement(Select.Option, {
      value: entity.id,
      key: entity.id
    }, entity._instanceName);
  }));
});

var __rest$1 = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var FormField = injectMainStore(observer(function (props) {
  var entityName = props.entityName,
      propertyName = props.propertyName,
      optionsContainer = props.optionsContainer,
      mainStore = props.mainStore,
      rest = __rest$1(props, ["entityName", "propertyName", "optionsContainer", "mainStore"]);

  if (mainStore == null || mainStore.metadata == null) {
    return createElement(Input, Object.assign({}, rest));
  }

  var propertyInfo = getPropertyInfo(mainStore.metadata, entityName, propertyName);

  if (propertyInfo == null) {
    return createElement(Input, Object.assign({}, rest));
  }

  if (isFileProperty(propertyInfo)) {
    return createElement(fileUpload, Object.assign({}, rest));
  }

  switch (propertyInfo.attributeType) {
    case 'ENUM':
      return createElement(EnumField, Object.assign({
        enumClass: propertyInfo.type,
        allowClear: getAllowClear(propertyInfo)
      }, rest));

    case 'ASSOCIATION':
      var mode = getSelectMode(propertyInfo.cardinality);
      return createElement(EntitySelectField, Object.assign({}, {
        mode: mode,
        optionsContainer: optionsContainer
      }, {
        allowClear: getAllowClear(propertyInfo)
      }, rest));

    case 'COMPOSITION':
      return createElement(EntitySelectField, Object.assign({}, rest, {
        allowClear: getAllowClear(propertyInfo)
      }));
  }

  switch (propertyInfo.type) {
    case 'boolean':
      return createElement(Checkbox, Object.assign({}, rest));

    case 'date':
      return createElement(DatePicker, Object.assign({}, rest));

    case 'dateTime':
      return createElement(DatePicker, Object.assign({
        showTime: true
      }, rest));

    case 'time':
      return createElement(TimePicker, Object.assign({}, rest));
  }

  return createElement(Input, Object.assign({}, rest));
}));
var EnumField = injectMainStore(observer(function (_a) {
  var enumClass = _a.enumClass,
      mainStore = _a.mainStore,
      rest = __rest$1(_a, ["enumClass", "mainStore"]);

  var enumValues = [];

  if (mainStore.enums != null) {
    var enumInfo = mainStore.enums.find(function (enm) {
      return enm.name === enumClass;
    });

    if (enumInfo != null) {
      enumValues = enumInfo.values;
    }
  }

  return createElement(Select, Object.assign({}, rest), enumValues.map(function (enumValue) {
    return createElement(Select.Option, {
      key: enumValue.name,
      value: enumValue.name
    }, enumValue.caption);
  }));
}));

function getSelectMode(cardinality) {
  if (cardinality === "ONE_TO_MANY" || cardinality === "MANY_TO_MANY") {
    return "multiple";
  }

  return "default";
}

function getAllowClear(propertyInfo) {
  return !propertyInfo.mandatory;
}

var Msg = injectMainStore(observer(function (_ref10) {
  var entityName = _ref10.entityName,
      propertyName = _ref10.propertyName,
      mainStore = _ref10.mainStore;

  if (mainStore == null || mainStore.messages == null) {
    return createElement(Fragment, null, "propertyName");
  }

  var messages = mainStore.messages;
  var message = messages[entityName + '.' + propertyName];
  return message != null ? createElement(Fragment, null, message) : createElement(Fragment, null, propertyName);
}));
var FieldPermissionContainer = injectMainStore(observer(function (props) {
  if (!props.mainStore) return null;
  var entityName = props.entityName,
      propertyName = props.propertyName;
  var getAttributePermission = props.mainStore.security.getAttributePermission;
  var perm = getAttributePermission(entityName, propertyName);
  var isAllowed = perm === 'MODIFY';
  var isReadOnly = perm === 'VIEW';
  if (!isAllowed && !isReadOnly) return null;
  return createElement(Fragment, null, props.renderField(isReadOnly));
})); // noinspection JSUnusedGlobalSymbols

var Field = injectMainStore(observer(function (props) {
  var getFieldDecorator = props.form.getFieldDecorator;
  var entityName = props.entityName,
      propertyName = props.propertyName,
      optionsContainer = props.optionsContainer,
      fieldDecoratorId = props.fieldDecoratorId,
      getFieldDecoratorOpts = props.getFieldDecoratorOpts,
      formItemKey = props.formItemKey;
  var formItemOpts = Object.assign({}, props.formItemOpts);
  if (!formItemOpts.label) formItemOpts.label = createElement(Msg, {
    entityName: entityName,
    propertyName: propertyName
  });
  return createElement(FieldPermissionContainer, {
    entityName: entityName,
    propertyName: propertyName,
    renderField: function renderField(isReadOnly) {
      return createElement(Form.Item, Object.assign({
        key: formItemKey ? formItemKey : propertyName
      }, formItemOpts), getFieldDecorator(fieldDecoratorId ? fieldDecoratorId : propertyName, getFieldDecoratorOpts)(createElement(FormField, {
        entityName: entityName,
        propertyName: propertyName,
        disabled: isReadOnly,
        optionsContainer: optionsContainer
      })));
    }
  });
}));

var DataTableCell = function DataTableCell(props) {
  if (props.propertyInfo.type === 'boolean') {
    return React__default.createElement(Checkbox, {
      checked: props.text,
      disabled: true
    });
  } else if (props.propertyInfo.attributeType === 'ENUM') {
    return React__default.createElement(EnumCell, {
      text: props.text,
      propertyInfo: props.propertyInfo,
      mainStore: props.mainStore
    });
  } else {
    return React__default.createElement("div", null, props.text);
  }
};

var EnumCell = function EnumCell(props) {
  var caption = getEnumCaption(props.text, props.propertyInfo, props.mainStore.enums);

  if (caption) {
    return React__default.createElement("div", null, caption);
  } else {
    return React__default.createElement("div", null);
  }
};

var __decorate$6 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var DataTableListEditorDateTimePickerComponent =
/*#__PURE__*/
function (_Component4) {
  _inherits(DataTableListEditorDateTimePickerComponent, _Component4);

  function DataTableListEditorDateTimePickerComponent() {
    var _this20;

    _classCallCheck(this, DataTableListEditorDateTimePickerComponent);

    _this20 = _possibleConstructorReturn(this, _getPrototypeOf(DataTableListEditorDateTimePickerComponent).apply(this, arguments));

    _this20.onMomentChange = function (newMoment, _dateString) {
      if (newMoment) {
        _this20.moment = newMoment;
      }
    };

    _this20.onConfirm = function () {
      var caption = _this20.moment.format('YYYY-MM-DD HH:mm:ss');

      var value = caption + '.000';

      _this20.props.onInputChange(value, caption);

      _this20.props.onInputConfirm();
    };

    return _this20;
  }

  _createClass(DataTableListEditorDateTimePickerComponent, [{
    key: "render",
    value: function render() {
      return createElement("div", {
        className: 'cuba-filter-controls-layout -no-wrap'
      }, createElement(Form.Item, {
        hasFeedback: true,
        className: 'filtercontrol'
      }, this.props.getFieldDecorator("".concat(this.props.id, ".input"), {
        initialValue: null,
        rules: [{
          required: true,
          message: this.props.intl.formatMessage({
            id: 'cubaReact.dataTable.requiredField'
          })
        }]
      })(createElement(DatePicker, {
        placeholder: 'YYYY-MM-DD',
        onChange: this.onMomentChange
      }))), createElement(Form.Item, {
        hasFeedback: true,
        className: 'filtercontrol'
      }, this.props.getFieldDecorator("".concat(this.props.id, ".input"), {
        initialValue: null,
        rules: [{
          required: true,
          message: this.props.intl.formatMessage({
            id: 'cubaReact.dataTable.requiredField'
          })
        }]
      })(createElement(TimePicker, {
        placeholder: 'HH:mm:ss',
        defaultOpenValue: moment__default('00:00:00', 'HH:mm:ss'),
        onChange: this.onMomentChange
      }))), createElement(Form.Item, {
        className: 'filtercontrol'
      }, createElement(Button, {
        htmlType: 'button',
        disabled: !this.moment,
        onClick: this.onConfirm,
        type: 'default'
      }, "Add")));
    }
  }]);

  return DataTableListEditorDateTimePickerComponent;
}(Component);

__decorate$6([observable.ref], DataTableListEditorDateTimePickerComponent.prototype, "moment", void 0);

__decorate$6([action], DataTableListEditorDateTimePickerComponent.prototype, "onMomentChange", void 0);

__decorate$6([action], DataTableListEditorDateTimePickerComponent.prototype, "onConfirm", void 0);

var dataTableListEditorDateTimePicker = injectIntl(DataTableListEditorDateTimePickerComponent);

var __decorate$7 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var DataTableListEditorType;

(function (DataTableListEditorType) {
  DataTableListEditorType["TEXT"] = "text";
  DataTableListEditorType["NUMBER"] = "number";
  DataTableListEditorType["DATE"] = "date";
  DataTableListEditorType["TIME"] = "time";
  DataTableListEditorType["DATETIME"] = "datetime";
  DataTableListEditorType["SELECT"] = "select";
})(DataTableListEditorType || (DataTableListEditorType = {}));

var DataTableListEditor =
/*#__PURE__*/
function (_Component5) {
  _inherits(DataTableListEditor, _Component5);

  function DataTableListEditor() {
    var _this21;

    _classCallCheck(this, DataTableListEditor);

    _this21 = _possibleConstructorReturn(this, _getPrototypeOf(DataTableListEditor).apply(this, arguments));
    _this21.inputVisible = false;
    _this21.inputModel = {
      caption: '',
      value: undefined
    };
    _this21.items = [];

    _this21.handleClose = function (item) {
      _this21.items = _this21.items.filter(function (savedItem) {
        return savedItem !== item;
      });

      if (_this21.type === DataTableListEditorType.SELECT) {
        _this21.availableOptions = [].concat(_toConsumableArray(_this21.availableOptions), [item]);
      }

      _this21.props.onChange(_this21.items.map(function (savedItem) {
        return savedItem.value;
      }));
    };

    _this21.onTextInputChange = function (event) {
      _this21.handleInputChange(event.target.value);
    };

    _this21.onInputBlurOrEnter = function (event) {
      event.preventDefault();

      _this21.handleInputConfirm();
    };

    _this21.onDatePickerChange = function (_date, dateString) {
      _this21.handleInputChange(dateString);

      _this21.handleInputConfirm();
    };

    _this21.onTimePickerChange = function (time, _timeString) {
      if (time) {
        var timeParam = time.format('HH:mm:ss');

        _this21.handleInputChange(timeParam);
      }
    };

    _this21.onTimePickerOpenChange = function (open) {
      if (!open && _this21.inputModel) {
        _this21.handleInputConfirm();
      }
    };

    _this21.onSelect = function (value) {
      var caption = _this21.props.nestedEntityOptions.find(function (option) {
        return option.value === value;
      }).caption;

      _this21.handleInputChange(value, caption);

      _this21.availableOptions = _this21.availableOptions.filter(function (option) {
        return option.value !== value;
      });

      _this21.handleInputConfirm();
    };

    _this21.handleInputChange = function (value) {
      var caption = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : value;
      _this21.inputModel.value = value;
      _this21.inputModel.caption = caption;
    };

    _this21.handleInputNumberChange = function (value) {
      var num = Number(value);

      if (!isNaN(num)) {
        _this21.inputModel.value = num;
        _this21.inputModel.caption = String(num);
      }
    };

    _this21.handleInputConfirm = function () {
      if (_this21.inputModel && _this21.inputModel.value != null && _this21.items.findIndex(function (item) {
        return item.value === _this21.inputModel.value;
      }) === -1) {
        _this21.items = [].concat(_toConsumableArray(_this21.items), [Object.assign({}, _this21.inputModel)]);
        _this21.inputModel.value = undefined;
        _this21.inputModel.caption = '';
        _this21.inputVisible = false;

        _this21.props.onChange(_this21.items.map(function (item) {
          return item.value;
        }));
      }
    };

    _this21.showInput = function () {
      _this21.inputVisible = true;
    };

    _this21.trapFocus = function (input) {
      if (input) {
        input.focus();
      }
    };

    return _this21;
  }

  _createClass(DataTableListEditor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.availableOptions = _toConsumableArray(this.props.nestedEntityOptions);
      this.getFieldDecorator = this.props.getFieldDecorator;
    }
  }, {
    key: "render",
    value: function render() {
      var _this22 = this;

      return createElement("div", null, this.items.map(function (item) {
        return item.value != null ? createElement(ListItemTag, {
          item: item,
          onClose: _this22.handleClose,
          key: item.value
        }) : null;
      }), this.inputVisible && createElement(Form.Item, {
        className: 'filtercontrol'
      }, this.input), !this.inputVisible && createElement(Tag, {
        onClick: this.showInput,
        color: 'blue',
        className: 'cuba-list-editor-input'
      }, createElement(Icon, {
        type: "plus"
      }), "\xA0", createElement(FormattedMessage, {
        id: 'cubaReact.dataTable.listEditor.addItem'
      })));
    }
  }, {
    key: "type",
    get: function get() {
      if (this.props.propertyInfo.attributeType === 'ASSOCIATION' || this.props.propertyInfo.attributeType === 'COMPOSITION') {
        return DataTableListEditorType.SELECT;
      } else {
        switch (this.props.propertyInfo.type) {
          case 'string':
            return DataTableListEditorType.TEXT;

          case 'int':
          case 'double':
          case 'decimal':
            return DataTableListEditorType.NUMBER;

          case 'date':
            return DataTableListEditorType.DATE;

          case 'time':
            return DataTableListEditorType.TIME;

          case 'dateTime':
            return DataTableListEditorType.DATETIME;

          default:
            throw new Error("Unexpected property type ".concat(this.props.propertyInfo.type));
        }
      }
    }
  }, {
    key: "input",
    get: function get() {
      switch (this.type) {
        case DataTableListEditorType.TEXT:
          return createElement("div", null, createElement(Input, {
            ref: this.trapFocus,
            type: 'text',
            size: 'small',
            "v-model": this.inputModel.value,
            onChange: this.onTextInputChange,
            onBlur: this.onInputBlurOrEnter,
            onPressEnter: this.onInputBlurOrEnter
          }));

        case DataTableListEditorType.NUMBER:
          // @ts-ignore
          return createElement("div", null, createElement(InputNumber, {
            ref: this.trapFocus,
            type: 'text',
            size: 'small',
            value: this.inputModel.value,
            onChange: this.handleInputNumberChange,
            onBlur: this.onInputBlurOrEnter,
            onPressEnter: this.onInputBlurOrEnter
          }));

        case DataTableListEditorType.DATE:
          return createElement("div", null, createElement(DatePicker, {
            placeholder: 'YYYY-MM-DD',
            onChange: this.onDatePickerChange
          }));

        case DataTableListEditorType.TIME:
          return createElement("div", null, createElement(TimePicker, {
            placeholder: 'HH:mm:ss',
            defaultOpenValue: moment__default('00:00:00', 'HH:mm:ss'),
            onChange: this.onTimePickerChange,
            onOpenChange: this.onTimePickerOpenChange
          }));

        case DataTableListEditorType.DATETIME:
          return createElement(dataTableListEditorDateTimePicker, {
            getFieldDecorator: this.getFieldDecorator,
            id: this.props.id,
            onInputChange: this.handleInputChange,
            onInputConfirm: this.handleInputConfirm
          });

        case DataTableListEditorType.SELECT:
          return createElement("div", null, createElement(Select, {
            dropdownMatchSelectWidth: false,
            className: 'cuba-filter-select',
            onSelect: this.onSelect
          }, this.selectFieldOptions));

        default:
          throw new Error("Unexpected ListEditorType ".concat(this.type));
      }
    }
  }, {
    key: "selectFieldOptions",
    get: function get() {
      return this.availableOptions.map(function (option) {
        return createElement(Select.Option, {
          title: option.caption,
          value: option.value,
          key: option.value
        }, option.caption);
      });
    }
  }]);

  return DataTableListEditor;
}(Component);

__decorate$7([observable], DataTableListEditor.prototype, "inputVisible", void 0);

__decorate$7([observable], DataTableListEditor.prototype, "inputModel", void 0);

__decorate$7([observable], DataTableListEditor.prototype, "items", void 0);

__decorate$7([observable], DataTableListEditor.prototype, "availableOptions", void 0);

__decorate$7([computed], DataTableListEditor.prototype, "type", null);

__decorate$7([action], DataTableListEditor.prototype, "handleClose", void 0);

__decorate$7([action], DataTableListEditor.prototype, "onTextInputChange", void 0);

__decorate$7([action], DataTableListEditor.prototype, "onInputBlurOrEnter", void 0);

__decorate$7([action], DataTableListEditor.prototype, "onDatePickerChange", void 0);

__decorate$7([action], DataTableListEditor.prototype, "onTimePickerChange", void 0);

__decorate$7([action], DataTableListEditor.prototype, "onTimePickerOpenChange", void 0);

__decorate$7([action], DataTableListEditor.prototype, "onSelect", void 0);

__decorate$7([action], DataTableListEditor.prototype, "handleInputChange", void 0);

__decorate$7([action], DataTableListEditor.prototype, "handleInputNumberChange", void 0);

__decorate$7([action], DataTableListEditor.prototype, "handleInputConfirm", void 0);

__decorate$7([action], DataTableListEditor.prototype, "showInput", void 0);

__decorate$7([computed], DataTableListEditor.prototype, "input", null);

__decorate$7([computed], DataTableListEditor.prototype, "selectFieldOptions", null);

DataTableListEditor = __decorate$7([observer], DataTableListEditor);

function ListItemTag(props) {
  var item = props.item,
      _onClose = props.onClose;
  var isLong = item.caption.length > 20;
  var tag = createElement(Tag, {
    closable: true,
    onClose: function onClose() {
      return _onClose(item);
    }
  }, isLong ? "".concat(item.caption.substr(0, 20), "...") : item.caption);
  return isLong ? createElement(Tooltip, {
    title: item.caption
  }, tag) : tag;
}

function determineLastNextXInterval(mode, numberOfUnits, timeUnit, includeCurrent) {
  var minDate;
  var maxDate;

  if (mode === 'last') {
    maxDate = moment__default().subtract(includeCurrent ? 0 : 1, timeUnit).endOf(timeUnit);
    minDate = moment__default().subtract(numberOfUnits - (includeCurrent ? 1 : 0), timeUnit).startOf(timeUnit);
  } else if (mode === 'next') {
    minDate = moment__default().add(includeCurrent ? 0 : 1, timeUnit).startOf(timeUnit);
    maxDate = moment__default().add(numberOfUnits + (includeCurrent ? -1 : 0), timeUnit).endOf(timeUnit);
  } else {
    throw new Error("Expected 'last' or 'next' mode, encountered '".concat(mode, "' mode"));
  }

  return {
    minDate: formatDate(minDate),
    maxDate: formatDate(maxDate)
  };
}

function determinePredefinedInterval(option) {
  var minDate;
  var maxDate;

  switch (option) {
    case 'today':
      minDate = moment__default().startOf('day');
      maxDate = moment__default().endOf('day');
      break;

    case 'yesterday':
      minDate = moment__default().subtract(1, 'days').startOf('day');
      maxDate = moment__default().subtract(1, 'days').endOf('day');
      break;

    case 'tomorrow':
      minDate = moment__default().add(1, 'days').startOf('day');
      maxDate = moment__default().add(1, 'days').endOf('day');
      break;

    case 'lastMonth':
      minDate = moment__default().subtract(1, 'months').startOf('month');
      maxDate = moment__default().subtract(1, 'months').endOf('month');
      break;

    case 'thisMonth':
      minDate = moment__default().startOf('month');
      maxDate = moment__default().endOf('month');
      break;

    case 'nextMonth':
      minDate = moment__default().add(1, 'months').startOf('month');
      maxDate = moment__default().add(1, 'months').endOf('month');
      break;

    default:
      throw new Error('Unexpected PredefinedIntervalOption' + option);
  }

  return {
    minDate: formatDate(minDate),
    maxDate: formatDate(maxDate)
  };
}

function formatDate(date) {
  var format = 'YYYY-MM-DD HH:mm:ss.000';
  return date.format(format);
}

var __decorate$8 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var DataTableIntervalEditorComponent =
/*#__PURE__*/
function (_React__default$Compo) {
  _inherits(DataTableIntervalEditorComponent, _React__default$Compo);

  function DataTableIntervalEditorComponent() {
    var _this23;

    _classCallCheck(this, DataTableIntervalEditorComponent);

    _this23 = _possibleConstructorReturn(this, _getPrototypeOf(DataTableIntervalEditorComponent).apply(this, arguments));
    _this23.mode = 'last';
    _this23.option = 'today';
    _this23.numberOfUnits = 5;
    _this23.timeUnit = 'days';
    _this23.includeCurrent = false;

    _this23.onModeChanged = function (e) {
      _this23.mode = e.target.value;

      _this23.props.onChange(_this23.interval);
    };

    _this23.onPredefinedIntervalOptionChanged = function (option) {
      _this23.option = option;

      _this23.props.onChange(_this23.interval);
    };

    _this23.onIntervalNumberChanged = function (value) {
      if (value) {
        _this23.numberOfUnits = value;

        _this23.props.onChange(_this23.interval);
      }
    };

    _this23.onIntervalUnitChanged = function (unit) {
      _this23.timeUnit = unit;

      _this23.props.onChange(_this23.interval);
    };

    _this23.onIncludeCurrentChanged = function (includeCurrent) {
      _this23.includeCurrent = includeCurrent.target.checked;

      _this23.props.onChange(_this23.interval);
    };

    return _this23;
  }

  _createClass(DataTableIntervalEditorComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onChange(this.interval);
    }
  }, {
    key: "render",
    value: function render() {
      return React__default.createElement("div", {
        className: 'cuba-filter-controls-layout'
      }, this.modeSelect, this.mode === 'predefined' ? this.predefinedIntervals : this.intervalInput);
    }
  }, {
    key: "interval",
    get: function get() {
      return this.mode === 'predefined' ? determinePredefinedInterval(this.option) : determineLastNextXInterval(this.mode, this.numberOfUnits, this.timeUnit, this.includeCurrent);
    }
  }, {
    key: "modeSelect",
    get: function get() {
      return React__default.createElement(Radio.Group, {
        className: 'cuba-interval-mode-select',
        onChange: this.onModeChanged,
        value: this.mode
      }, React__default.createElement(Radio, {
        value: 'last'
      }, React__default.createElement(FormattedMessage, {
        id: 'cubaReact.dataTable.intervalEditor.last'
      })), React__default.createElement(Radio, {
        value: 'next'
      }, React__default.createElement(FormattedMessage, {
        id: 'cubaReact.dataTable.intervalEditor.next'
      })), React__default.createElement(Radio, {
        value: 'predefined'
      }, React__default.createElement(FormattedMessage, {
        id: 'cubaReact.dataTable.intervalEditor.predefined'
      })));
    }
  }, {
    key: "predefinedIntervals",
    get: function get() {
      return React__default.createElement(Form.Item, {
        className: 'filtercontrol'
      }, this.props.getFieldDecorator("".concat(this.props.id, ".predefined"), {
        initialValue: this.option,
        rules: [{
          required: true,
          message: this.props.intl.formatMessage({
            id: 'cubaReact.dataTable.requiredField'
          })
        }]
      })(React__default.createElement(Select, {
        onChange: this.onPredefinedIntervalOptionChanged,
        dropdownMatchSelectWidth: false,
        className: 'cuba-interval-predefined-select'
      }, React__default.createElement(Select.Option, {
        value: 'today'
      }, React__default.createElement(FormattedMessage, {
        id: 'cubaReact.dataTable.intervalEditor.today'
      })), React__default.createElement(Select.Option, {
        value: 'yesterday'
      }, React__default.createElement(FormattedMessage, {
        id: 'cubaReact.dataTable.intervalEditor.yesterday'
      })), React__default.createElement(Select.Option, {
        value: 'tomorrow'
      }, React__default.createElement(FormattedMessage, {
        id: 'cubaReact.dataTable.intervalEditor.tomorrow'
      })), React__default.createElement(Select.Option, {
        value: 'lastMonth'
      }, React__default.createElement(FormattedMessage, {
        id: 'cubaReact.dataTable.intervalEditor.lastMonth'
      })), React__default.createElement(Select.Option, {
        value: 'thisMonth'
      }, React__default.createElement(FormattedMessage, {
        id: 'cubaReact.dataTable.intervalEditor.thisMonth'
      })), React__default.createElement(Select.Option, {
        value: 'nextMonth'
      }, React__default.createElement(FormattedMessage, {
        id: 'cubaReact.dataTable.intervalEditor.nextMonth'
      })))));
    }
  }, {
    key: "intervalInput",
    get: function get() {
      return React__default.createElement("div", {
        className: 'cuba-filter-controls-layout'
      }, React__default.createElement(Form.Item, {
        key: "".concat(this.props.id, ".wrap.number"),
        className: 'filtercontrol'
      }, this.props.getFieldDecorator("".concat(this.props.id, ".number"), {
        initialValue: this.numberOfUnits,
        rules: [{
          required: true,
          message: this.props.intl.formatMessage({
            id: 'cubaReact.dataTable.requiredField'
          })
        }]
      })(React__default.createElement(InputNumber, {
        onChange: this.onIntervalNumberChanged
      }))), React__default.createElement(Form.Item, {
        key: "".concat(this.props.id, ".wrap.unit"),
        className: 'filtercontrol'
      }, React__default.createElement(Select, {
        defaultValue: this.timeUnit,
        onChange: this.onIntervalUnitChanged,
        dropdownMatchSelectWidth: false
      }, React__default.createElement(Select.Option, {
        value: 'days'
      }, React__default.createElement(FormattedMessage, {
        id: 'cubaReact.dataTable.intervalEditor.days'
      })), React__default.createElement(Select.Option, {
        value: 'hours'
      }, React__default.createElement(FormattedMessage, {
        id: 'cubaReact.dataTable.intervalEditor.hours'
      })), React__default.createElement(Select.Option, {
        value: 'minutes'
      }, React__default.createElement(FormattedMessage, {
        id: 'cubaReact.dataTable.intervalEditor.minutes'
      })), React__default.createElement(Select.Option, {
        value: 'months'
      }, React__default.createElement(FormattedMessage, {
        id: 'cubaReact.dataTable.intervalEditor.months'
      })))), React__default.createElement(Form.Item, {
        key: "".concat(this.props.id, ".wrap.includeCurrent"),
        className: 'filtercontrol'
      }, React__default.createElement(Checkbox, {
        onChange: this.onIncludeCurrentChanged,
        className: 'cuba-interval-include-current',
        defaultChecked: this.includeCurrent
      }, React__default.createElement(FormattedMessage, {
        id: 'cubaReact.dataTable.intervalEditor.includingCurrent'
      }))));
    }
  }]);

  return DataTableIntervalEditorComponent;
}(React__default.Component);

__decorate$8([observable], DataTableIntervalEditorComponent.prototype, "mode", void 0);

__decorate$8([observable], DataTableIntervalEditorComponent.prototype, "option", void 0);

__decorate$8([observable], DataTableIntervalEditorComponent.prototype, "numberOfUnits", void 0);

__decorate$8([observable], DataTableIntervalEditorComponent.prototype, "timeUnit", void 0);

__decorate$8([observable], DataTableIntervalEditorComponent.prototype, "includeCurrent", void 0);

__decorate$8([computed], DataTableIntervalEditorComponent.prototype, "interval", null);

__decorate$8([action], DataTableIntervalEditorComponent.prototype, "onModeChanged", void 0);

__decorate$8([action], DataTableIntervalEditorComponent.prototype, "onPredefinedIntervalOptionChanged", void 0);

__decorate$8([action], DataTableIntervalEditorComponent.prototype, "onIntervalNumberChanged", void 0);

__decorate$8([action], DataTableIntervalEditorComponent.prototype, "onIntervalUnitChanged", void 0);

__decorate$8([action], DataTableIntervalEditorComponent.prototype, "onIncludeCurrentChanged", void 0);

__decorate$8([computed], DataTableIntervalEditorComponent.prototype, "modeSelect", null);

__decorate$8([computed], DataTableIntervalEditorComponent.prototype, "predefinedIntervals", null);

__decorate$8([computed], DataTableIntervalEditorComponent.prototype, "intervalInput", null);

DataTableIntervalEditorComponent = __decorate$8([observer], DataTableIntervalEditorComponent);
var dataTableIntervalEditor = injectIntl(DataTableIntervalEditorComponent);

var __decorate$9 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var OperatorGroup;

(function (OperatorGroup) {
  OperatorGroup["SINGLE_VALUE"] = "singleValue";
  OperatorGroup["LIST_VALUE"] = "listValue";
  OperatorGroup["LOGICAL_VALUE"] = "logicalValue";
  OperatorGroup["INTERVAL_VALUE"] = "intervalValue";
})(OperatorGroup || (OperatorGroup = {}));

var DataTableCustomFilterComponent =
/*#__PURE__*/
function (_React__default$Compo2) {
  _inherits(DataTableCustomFilterComponent, _React__default$Compo2);

  function DataTableCustomFilterComponent(props) {
    var _this24;

    _classCallCheck(this, DataTableCustomFilterComponent);

    _this24 = _possibleConstructorReturn(this, _getPrototypeOf(DataTableCustomFilterComponent).call(this, props));
    _this24.nestedEntityOptions = [];
    _this24.loading = true;

    _this24.handleSubmit = function (e) {
      e.preventDefault();
      e.stopPropagation();

      _this24.props.form.validateFields(function (err) {
        if (!err) {
          _this24.props.filterProps.setSelectedKeys([JSON.stringify({
            operator: _this24.operator,
            value: _this24.value
          })]);

          _this24.props.filterProps.confirm();
        }
      });
    };

    _this24.resetFilter = function () {
      if (_this24.propertyInfoNN.type === 'boolean') {
        _this24.value = 'true';
      } else {
        _this24.value = null;
      }

      _this24.props.form.resetFields();

      _this24.operator = _this24.getDefaultOperator(); // @ts-ignore

      _this24.props.filterProps.clearFilters(_this24.props.filterProps.selectedKeys);
    };

    _this24.changeOperator = function (newOperator) {
      var oldOperator = _this24.operator;
      var oldOperatorGroup = determineOperatorGroup(oldOperator);
      var newOperatorGroup = determineOperatorGroup(newOperator);

      if (oldOperatorGroup !== newOperatorGroup) {
        _this24.props.form.resetFields();

        _this24.value = null;
      }

      _this24.operator = newOperator;

      _this24.setDefaultYesNoDropdown();
    };

    _this24.setDefaultYesNoDropdown = function () {
      if (!_this24.value && (_this24.operator === 'notEmpty' || _this24.propertyInfoNN.type === 'boolean')) {
        _this24.value = 'true';
      }
    };

    _this24.onTextInputChange = function (event) {
      _this24.value = event.target.value;
    };

    _this24.onDatePickerChange = function (_date, dateString) {
      _this24.value = dateString;
    };

    _this24.onTimePickerChange = function (time, _timeString) {
      if (time) {
        _this24.value = time.format('HH:mm:ss.mmm');
      }
    };

    _this24.onDateTimePickerChange = function (dateTime, _timeString) {
      if (dateTime) {
        _this24.value = dateTime.format('YYYY-MM-DD HH:mm:ss.000');
      }
    };

    _this24.setValue = function (value) {
      _this24.value = value;
    };

    _this24.getOperatorCaption = function (operator) {
      switch (operator) {
        case '=':
        case '>':
        case '>=':
        case '<':
        case '<=':
        case '<>':
          return operator;

        case 'startsWith':
        case 'endsWith':
        case 'contains':
        case 'doesNotContain':
        case 'in':
        case 'notIn':
        case 'notEmpty':
        case 'inInterval':
          return _this24.props.intl.formatMessage({
            id: 'cubaReact.dataTable.operator.' + operator
          });

        default:
          throw new Error("Unexpected ComparisonType ".concat(operator));
      }
    };

    _this24.setDefaultYesNoDropdown();

    return _this24;
  }

  _createClass(DataTableCustomFilterComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this25 = this;

      var propertyInfo = this.propertyInfoNN;
      var metaClassInfo = this.props.mainStore.metadata.find(function (classInfo) {
        return classInfo.entityName === propertyInfo.type;
      });

      if (metaClassInfo) {
        // This is a nested entity column. Fetch select options.
        getCubaREST().loadEntities(metaClassInfo.entityName, {
          view: '_minimal'
        }).then(function (resp) {
          resp.forEach(function (instance) {
            _this25.nestedEntityOptions.push({
              caption: instance._instanceName,
              value: instance.id
            });
          });
          _this25.loading = false;
        }).catch(function () {
          message.error(_this25.props.intl.formatMessage({
            id: 'cubaReact.dataTable.failedToLoadNestedEntities'
          }));
          _this25.loading = false;
        });
      } else {
        this.loading = false;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this26 = this;

      this.getFieldDecorator = this.props.form.getFieldDecorator;

      if (this.loading) {
        return React__default.createElement(Spin, {
          tip: this.props.intl.formatMessage({
            id: 'cubaReact.dataTable.loading'
          }),
          className: 'cuba-table-filter-loader'
        });
      }

      return React__default.createElement(Form, {
        layout: 'inline',
        onSubmit: this.handleSubmit
      }, React__default.createElement("div", {
        className: 'cuba-table-filter'
      }, React__default.createElement("div", {
        className: 'settings'
      }, React__default.createElement("div", {
        className: 'cuba-filter-controls-layout'
      }, React__default.createElement(Form.Item, {
        className: 'filtercontrol -property-caption'
      }, this.propertyCaption), React__default.createElement(Form.Item, {
        className: 'filtercontrol'
      }, this.getFieldDecorator("".concat(this.props.entityProperty, ".operatorsDropdown"), {
        initialValue: this.getDefaultOperator()
      })(React__default.createElement(Select, {
        dropdownMatchSelectWidth: false,
        onChange: function onChange(operator) {
          return _this26.changeOperator(operator);
        }
      }, this.operatorTypeOptions))), this.simpleFilterEditor), this.complexFilterEditor), React__default.createElement(Divider, {
        className: 'divider'
      }), React__default.createElement("div", {
        className: 'footer'
      }, React__default.createElement(Button, {
        htmlType: 'submit',
        type: 'link'
      }, React__default.createElement(FormattedMessage, {
        id: 'cubaReact.dataTable.ok'
      })), React__default.createElement(Button, {
        htmlType: 'button',
        type: 'link',
        onClick: this.resetFilter
      }, React__default.createElement(FormattedMessage, {
        id: 'cubaReact.dataTable.reset'
      })))));
    }
  }, {
    key: "getDefaultOperator",
    value: function getDefaultOperator() {
      var propertyInfo = this.propertyInfoNN;

      switch (propertyInfo.attributeType) {
        case 'ENUM':
        case 'ASSOCIATION':
        case 'COMPOSITION':
          return '=';
      }

      switch (propertyInfo.type) {
        case 'boolean':
          return '=';

        case 'date':
        case 'time':
        case 'dateTime':
          return '=';

        case 'int':
        case 'double':
        case 'decimal':
          return '=';

        case 'string':
          return 'contains';

        default:
          throw new Error("Unexpected property type ".concat(propertyInfo.type));
      }
    }
  }, {
    key: "operator",
    set: function set(operator) {
      this.props.onOperatorChange(operator, this.props.entityProperty);
    },
    get: function get() {
      return this.props.operator || this.getDefaultOperator();
    }
  }, {
    key: "value",
    set: function set(value) {
      this.props.onValueChange(value, this.props.entityProperty);
    },
    get: function get() {
      return this.props.value;
    }
  }, {
    key: "propertyCaption",
    get: function get() {
      return this.props.mainStore.messages[this.props.entityName + '.' + this.props.entityProperty];
    }
  }, {
    key: "propertyInfoNN",
    get: function get() {
      var propertyInfo = getPropertyInfo(this.props.mainStore.metadata, this.props.entityName, this.props.entityProperty);

      if (!propertyInfo) {
        throw new Error('Cannot find MetaPropertyInfo for property ' + this.props.entityProperty);
      }

      return propertyInfo;
    }
  }, {
    key: "operatorTypeOptions",
    get: function get() {
      var _this27 = this;

      var propertyInfo = this.propertyInfoNN;
      var availableOperators = getAvailableOperators(propertyInfo);
      return availableOperators.map(function (operator) {
        return React__default.createElement(Select.Option, {
          key: "".concat(_this27.props.entityProperty, ".").concat(operator),
          value: operator
        }, _this27.getOperatorCaption(operator));
      });
    }
  }, {
    key: "simpleFilterEditor",
    get: function get() {
      return isComplexOperator(this.operator) ? null : this.conditionInput;
    }
  }, {
    key: "complexFilterEditor",
    get: function get() {
      return isComplexOperator(this.operator) ? this.conditionInput : null;
    }
  }, {
    key: "conditionInput",
    get: function get() {
      var propertyInfo = this.propertyInfoNN;

      switch (propertyInfo.attributeType) {
        // In case of enum generic filter will not be rendered, enum filter will be rendered instead
        case 'ASSOCIATION':
        case 'COMPOSITION':
          switch (this.operator) {
            case '=':
            case '<>':
              return this.selectField;

            case 'in':
            case 'notIn':
              return this.listEditor;

            case 'notEmpty':
              return this.yesNoSelectField;
          }

      }

      switch (propertyInfo.type) {
        case 'boolean':
          return this.yesNoSelectField;

        case 'dateTime':
          switch (this.operator) {
            case '=':
            case '<>':
            case '>':
            case '>=':
            case '<':
            case '<=':
              return this.dateTimePickerField;

            case 'in':
            case 'notIn':
              return this.listEditor;

            case 'notEmpty':
              return this.yesNoSelectField;

            case 'inInterval':
              return this.intervalEditor;
          }

          throw new Error("Unexpected combination of property type ".concat(propertyInfo.type, " and condition operator ").concat(this.operator));

        case 'date':
          switch (this.operator) {
            case '=':
            case '<>':
            case '>':
            case '>=':
            case '<':
            case '<=':
              return this.datePickerField;

            case 'in':
            case 'notIn':
              return this.listEditor;

            case 'notEmpty':
              return this.yesNoSelectField;

            case 'inInterval':
              return this.intervalEditor;
          }

          throw new Error("Unexpected combination of property type ".concat(propertyInfo.type, " and condition operator ").concat(this.operator));

        case 'time':
          switch (this.operator) {
            case '=':
            case '<>':
            case '>':
            case '>=':
            case '<':
            case '<=':
              return this.timePickerField;

            case 'in':
            case 'notIn':
              return this.listEditor;

            case 'notEmpty':
              return this.yesNoSelectField;
          }

          throw new Error("Unexpected combination of property type ".concat(propertyInfo.type, " and condition operator ").concat(this.operator));

        case 'int':
        case 'double':
        case 'decimal':
          switch (this.operator) {
            case '=':
            case '<>':
            case '>':
            case '>=':
            case '<':
            case '<=':
              return this.numberInputField;

            case 'in':
            case 'notIn':
              return this.listEditor;

            case 'notEmpty':
              return this.yesNoSelectField;
          }

          throw new Error("Unexpected combination of property type ".concat(propertyInfo.type, " and condition operator ").concat(this.operator));

        case 'string':
          switch (this.operator) {
            case 'contains':
            case 'doesNotContain':
            case '=':
            case '<>':
            case 'startsWith':
            case 'endsWith':
              return this.textInputField;

            case 'in':
            case 'notIn':
              return this.listEditor;

            case 'notEmpty':
              return this.yesNoSelectField;
          }

          throw new Error("Unexpected combination of property type ".concat(propertyInfo.type, " and condition operator ").concat(this.operator));

        default:
          throw new Error("Unexpected combination of property type ".concat(propertyInfo.type, " and condition operator ").concat(this.operator));
      }
    }
  }, {
    key: "textInputField",
    get: function get() {
      return React__default.createElement(Form.Item, {
        hasFeedback: true,
        className: 'filtercontrol'
      }, this.getFieldDecorator("".concat(this.props.entityProperty, ".input"), {
        initialValue: null,
        rules: [{
          required: true,
          message: this.props.intl.formatMessage({
            id: 'cubaReact.dataTable.requiredField'
          })
        }]
      })(React__default.createElement(Input, {
        onChange: this.onTextInputChange
      })));
    }
  }, {
    key: "numberInputField",
    get: function get() {
      return React__default.createElement(Form.Item, {
        hasFeedback: true,
        className: 'filtercontrol'
      }, this.getFieldDecorator("".concat(this.props.entityProperty, ".input"), {
        initialValue: null,
        rules: [{
          required: true,
          message: this.props.intl.formatMessage({
            id: 'cubaReact.dataTable.requiredField'
          })
        }]
      })(React__default.createElement(InputNumber, {
        onChange: this.setValue
      })));
    }
  }, {
    key: "selectField",
    get: function get() {
      return React__default.createElement(Form.Item, {
        className: 'filtercontrol'
      }, this.getFieldDecorator("".concat(this.props.entityProperty, ".input"), {
        initialValue: null,
        rules: [{
          required: true,
          message: this.props.intl.formatMessage({
            id: 'cubaReact.dataTable.requiredField'
          })
        }]
      })(React__default.createElement(Select, {
        dropdownMatchSelectWidth: false,
        className: 'cuba-filter-select',
        onSelect: this.setValue
      }, this.selectFieldOptions)));
    }
  }, {
    key: "selectFieldOptions",
    get: function get() {
      return this.nestedEntityOptions.map(function (option) {
        return React__default.createElement(Select.Option, {
          title: option.caption,
          value: option.value,
          key: option.value
        }, option.caption);
      });
    }
  }, {
    key: "yesNoSelectField",
    get: function get() {
      return React__default.createElement(Form.Item, {
        className: 'filtercontrol'
      }, this.getFieldDecorator("".concat(this.props.entityProperty, ".input"), {
        initialValue: 'true',
        rules: [{
          required: true
        }]
      })(React__default.createElement(Select, {
        dropdownMatchSelectWidth: false,
        className: 'cuba-filter-select',
        onSelect: this.setValue
      }, React__default.createElement(Select.Option, {
        value: 'true'
      }, React__default.createElement(FormattedMessage, {
        id: 'cubaReact.dataTable.yes'
      })), React__default.createElement(Select.Option, {
        value: 'false'
      }, React__default.createElement(FormattedMessage, {
        id: 'cubaReact.dataTable.no'
      })))));
    }
  }, {
    key: "listEditor",
    get: function get() {
      var _this28 = this;

      return React__default.createElement(Form.Item, {
        className: 'filtercontrol -complex-editor'
      }, React__default.createElement(DataTableListEditor, {
        onChange: function onChange(value) {
          return _this28.value = value;
        },
        id: this.props.entityProperty,
        propertyInfo: this.propertyInfoNN,
        getFieldDecorator: this.props.form.getFieldDecorator,
        nestedEntityOptions: this.nestedEntityOptions
      }));
    }
  }, {
    key: "intervalEditor",
    get: function get() {
      var _this29 = this;

      return React__default.createElement(Form.Item, {
        className: 'filtercontrol -complex-editor'
      }, React__default.createElement(dataTableIntervalEditor, {
        onChange: function onChange(value) {
          return _this29.value = value;
        },
        id: this.props.entityProperty,
        getFieldDecorator: this.props.form.getFieldDecorator
      }));
    }
  }, {
    key: "datePickerField",
    get: function get() {
      return React__default.createElement(Form.Item, {
        hasFeedback: true,
        className: 'filtercontrol'
      }, this.getFieldDecorator("".concat(this.props.entityProperty, ".input"), {
        initialValue: null,
        rules: [{
          required: true,
          message: this.props.intl.formatMessage({
            id: 'cubaReact.dataTable.requiredField'
          })
        }]
      })(React__default.createElement(DatePicker, {
        placeholder: 'YYYY-MM-DD',
        onChange: this.onDatePickerChange
      })));
    }
  }, {
    key: "timePickerField",
    get: function get() {
      return React__default.createElement(Form.Item, {
        hasFeedback: true,
        className: 'filtercontrol'
      }, this.getFieldDecorator("".concat(this.props.entityProperty, ".input"), {
        initialValue: null,
        rules: [{
          required: true,
          message: this.props.intl.formatMessage({
            id: 'cubaReact.dataTable.requiredField'
          })
        }]
      })(React__default.createElement(TimePicker, {
        placeholder: 'HH:mm:ss',
        defaultOpenValue: moment__default('00:00:00', 'HH:mm:ss'),
        onChange: this.onTimePickerChange
      })));
    }
  }, {
    key: "dateTimePickerField",
    get: function get() {
      return React__default.createElement(Form.Item, {
        hasFeedback: true,
        className: 'filtercontrol'
      }, React__default.createElement("div", {
        className: 'cuba-filter-controls-layout'
      }, React__default.createElement(Form.Item, {
        hasFeedback: true,
        className: 'filtercontrol'
      }, this.getFieldDecorator("".concat(this.props.entityProperty, ".input"), {
        initialValue: null,
        rules: [{
          required: true,
          message: this.props.intl.formatMessage({
            id: 'cubaReact.dataTable.requiredField'
          })
        }]
      })(React__default.createElement(DatePicker, {
        placeholder: 'YYYY-MM-DD'
      }))), React__default.createElement(Form.Item, {
        hasFeedback: true,
        className: 'filtercontrol'
      }, this.getFieldDecorator("".concat(this.props.entityProperty, ".input"), {
        initialValue: null,
        rules: [{
          required: true,
          message: this.props.intl.formatMessage({
            id: 'cubaReact.dataTable.requiredField'
          })
        }]
      })(React__default.createElement(TimePicker, {
        placeholder: 'HH:mm:ss',
        defaultOpenValue: moment__default('00:00:00', 'HH:mm:ss'),
        onChange: this.onDateTimePickerChange
      })))));
    }
  }]);

  return DataTableCustomFilterComponent;
}(React__default.Component);

__decorate$9([observable], DataTableCustomFilterComponent.prototype, "nestedEntityOptions", void 0);

__decorate$9([observable], DataTableCustomFilterComponent.prototype, "loading", void 0);

__decorate$9([computed], DataTableCustomFilterComponent.prototype, "propertyCaption", null);

__decorate$9([computed], DataTableCustomFilterComponent.prototype, "propertyInfoNN", null);

__decorate$9([action], DataTableCustomFilterComponent.prototype, "handleSubmit", void 0);

__decorate$9([action], DataTableCustomFilterComponent.prototype, "resetFilter", void 0);

__decorate$9([action], DataTableCustomFilterComponent.prototype, "changeOperator", void 0);

__decorate$9([action], DataTableCustomFilterComponent.prototype, "setDefaultYesNoDropdown", void 0);

__decorate$9([action], DataTableCustomFilterComponent.prototype, "onTextInputChange", void 0);

__decorate$9([action], DataTableCustomFilterComponent.prototype, "onDatePickerChange", void 0);

__decorate$9([action], DataTableCustomFilterComponent.prototype, "onTimePickerChange", void 0);

__decorate$9([action], DataTableCustomFilterComponent.prototype, "onDateTimePickerChange", void 0);

__decorate$9([action], DataTableCustomFilterComponent.prototype, "setValue", void 0);

__decorate$9([computed], DataTableCustomFilterComponent.prototype, "operatorTypeOptions", null);

__decorate$9([computed], DataTableCustomFilterComponent.prototype, "simpleFilterEditor", null);

__decorate$9([computed], DataTableCustomFilterComponent.prototype, "complexFilterEditor", null);

__decorate$9([computed], DataTableCustomFilterComponent.prototype, "conditionInput", null);

__decorate$9([computed], DataTableCustomFilterComponent.prototype, "textInputField", null);

__decorate$9([computed], DataTableCustomFilterComponent.prototype, "numberInputField", null);

__decorate$9([computed], DataTableCustomFilterComponent.prototype, "selectField", null);

__decorate$9([computed], DataTableCustomFilterComponent.prototype, "selectFieldOptions", null);

__decorate$9([computed], DataTableCustomFilterComponent.prototype, "yesNoSelectField", null);

__decorate$9([computed], DataTableCustomFilterComponent.prototype, "listEditor", null);

__decorate$9([computed], DataTableCustomFilterComponent.prototype, "intervalEditor", null);

__decorate$9([computed], DataTableCustomFilterComponent.prototype, "datePickerField", null);

__decorate$9([computed], DataTableCustomFilterComponent.prototype, "timePickerField", null);

__decorate$9([computed], DataTableCustomFilterComponent.prototype, "dateTimePickerField", null);

DataTableCustomFilterComponent = __decorate$9([injectMainStore, observer], DataTableCustomFilterComponent);

function determineOperatorGroup(operator) {
  switch (operator) {
    case '=':
    case '>':
    case '>=':
    case '<':
    case '<=':
    case '<>':
    case 'startsWith':
    case 'endsWith':
    case 'contains':
    case 'doesNotContain':
      return OperatorGroup.SINGLE_VALUE;

    case 'in':
    case 'notIn':
      return OperatorGroup.LIST_VALUE;

    case 'notEmpty':
      return OperatorGroup.LOGICAL_VALUE;

    case 'inInterval':
      return OperatorGroup.INTERVAL_VALUE;

    default:
      throw new Error("Unexpected ComparisonType ".concat(operator));
  }
}

function getAvailableOperators(propertyInfo) {
  switch (propertyInfo.attributeType) {
    case 'ENUM':
    case 'ASSOCIATION':
    case 'COMPOSITION':
      return ['=', '<>', 'in', 'notIn', 'notEmpty'];
  }

  switch (propertyInfo.type) {
    case 'boolean':
      return ['=', '<>', 'notEmpty'];

    case 'date':
    case 'dateTime':
      return ['=', 'in', 'notIn', '<>', '>', '>=', '<', '<=', 'notEmpty', 'inInterval'];

    case 'time':
      return ['=', 'in', 'notIn', '<>', '>', '>=', '<', '<=', 'notEmpty'];

    case 'int':
    case 'double':
    case 'decimal':
      return ['=', 'in', 'notIn', '<>', '>', '>=', '<', '<=', 'notEmpty'];

    case 'string':
      return ['contains', '=', 'in', 'notIn', '<>', 'doesNotContain', 'notEmpty', 'startsWith', 'endsWith'];

    default:
      throw new Error("Unexpected property type ".concat(propertyInfo.type));
  }
}

function isComplexOperator(operator) {
  var complexOperators = ['in', 'notIn', 'inInterval'];
  return complexOperators.indexOf(operator) > -1;
}

var dataTableCustomFilter = Form.create()(injectIntl(DataTableCustomFilterComponent));
/**
 * @remarks
 * It is possible to create a vanilla antd `Table` and customize some of its columns
 * with `DataTable`'s custom filters using this helper function.
 *
 * @param config
 *
 * @example
 * ```typescript jsx
 *  import * as React from "react";
 *  import {action, observable} from 'mobx';
 *  import {observer} from "mobx-react";
 *  import {Table,} from "antd";
 *  import {Car} from "../../cuba/entities/mpg$Car";
 *  import {
 *   collection, injectMainStore, MainStoreInjected,
 *   generateDataColumn, ComparisonType, handleTableChange,
 * } from "@cuba-platform/react";
 *  import {injectIntl, WrappedComponentProps} from 'react-intl';
 *  import {PaginationConfig} from 'antd/es/pagination';
 *  import { SorterResult } from "antd/es/table";
 *
 *  @injectMainStore
 *  @observer
 *  class CarTableComponent extends React.Component<MainStoreInjected & WrappedComponentProps> {
 *
 *   dataCollection = collection<Car>(Car.NAME, {view: 'car-edit', sort: '-updateTs'});
 *
 *   fields = ['purchaseDate','price','regNumber'];
 *
 *   @observable.ref filters: Record<string, string[]> | undefined;
 *   @observable operator: ComparisonType | undefined;
 *   @observable value: any;
 *
 *   @action
 *   handleOperatorChange = (operator: ComparisonType) => this.operator = operator;
 *
 *   @action
 *   handleValueChange = (value: any) => this.value = value;
 *
 *   @action
 *   handleChange = (pagination: PaginationConfig, tableFilters: Record<string, string[]>, sorter: SorterResult<Car>): void => {
 *     this.filters = tableFilters;
 *
 *     handleTableChange({
 *       pagination: pagination,
 *       filters: tableFilters,
 *       sorter: sorter,
 *       defaultSort: '-updateTs',
 *       fields: this.fields,
 *       mainStore: this.props.mainStore!,
 *       dataCollection: this.dataCollection
 *     });
 *   };
 *
 *   render() {
 *
 *     return (
 *       <Table
 *         dataSource={this.dataCollection.items.slice()}
 *         columns={[
 *           { title: 'Purchase Date', dataIndex: 'purchaseDate', key: 'purchaseDate', render: (text: any) => <b>{text}</b> },
 *           { title: 'Price', dataIndex: 'price', key: 'price' },
 *           generateDataColumn({
 *             propertyName: 'regNumber',
 *             entityName: this.dataCollection.entityName,
 *             filters: this.filters,
 *             operator: this.operator,
 *             onOperatorChange: this.handleOperatorChange,
 *             value: this.value,
 *             onValueChange: this.handleValueChange,
 *             enableSorter: true,
 *             mainStore: this.props.mainStore!
 *           })
 *         ]}
 *         onChange={this.handleChange}
 *         pagination={{
 *           showSizeChanger: true,
 *           total: this.dataCollection.count,
 *         }}
 *       />
 *     );
 *   }
 *
 * }
 *
 *  const CarTable = injectIntl(CarTableComponent);
 *
 *  export default CarTable;
 *  ```
 */

function generateDataColumn(config) {
  var propertyName = config.propertyName,
      entityName = config.entityName,
      enableFilter = config.enableFilter,
      filters = config.filters,
      operator = config.operator,
      onOperatorChange = config.onOperatorChange,
      value = config.value,
      onValueChange = config.onValueChange,
      enableSorter = config.enableSorter,
      mainStore = config.mainStore,
      customFilterRef = config.customFilterRef;
  var dataIndex;
  var propertyInfo = getPropertyInfoNN(propertyName, entityName, mainStore.metadata);

  switch (propertyInfo.attributeType) {
    case 'COMPOSITION':
    case 'ASSOCIATION':
      dataIndex = "".concat(propertyName, "._instanceName");
      break;

    default:
      dataIndex = propertyName;
  }

  var localizedPropertyCaption = getPropertyCaption(propertyName, entityName, mainStore.messages);
  var defaultColumnProps = {
    title: React__default.createElement("div", {
      title: localizedPropertyCaption
    }, localizedPropertyCaption),
    dataIndex: dataIndex,
    sorter: enableSorter,
    key: propertyName,
    render: function render(text) {
      return renderCell(propertyInfo, text, mainStore);
    }
  };

  if (enableFilter && isPropertyTypeSupported(propertyInfo)) {
    defaultColumnProps = Object.assign({}, defaultColumnProps, {
      // According to the typings this field expects any[] | undefined
      // However, in reality undefined makes the filter icon to be highlighted.
      // If we want the icon to not be highlighted we need to pass null instead.
      // @ts-ignore
      filteredValue: filters && filters[propertyName] ? toJS(filters[propertyName]) : null
    });

    if (propertyInfo.attributeType === 'ENUM') {
      defaultColumnProps = Object.assign({
        filters: generateEnumFilter(propertyInfo, mainStore)
      }, defaultColumnProps);
    } else {
      defaultColumnProps = Object.assign({
        filterDropdown: generateCustomFilterDropdown(propertyName, entityName, operator, onOperatorChange, value, onValueChange, customFilterRef)
      }, defaultColumnProps);
    }
  }

  return defaultColumnProps;
}
/**
 * Generates a standard antd table column filter for enum fields.
 *
 * @param propertyInfo
 * @param mainStore
 */


function generateEnumFilter(propertyInfo, mainStore) {
  var propertyEnumInfo = mainStore.enums.find(function (enumInfo) {
    return enumInfo.name === propertyInfo.type;
  });

  if (!propertyEnumInfo) {
    return [];
  }

  return propertyEnumInfo.values.map(function (enumValueInfo) {
    return {
      text: enumValueInfo.caption,
      value: enumValueInfo.name
    };
  });
}
/**
 *
 * @param propertyName
 * @param entityName
 * @param operator
 * @param onOperatorChange
 * @param value
 * @param onValueChange
 * @param customFilterRefCallback
 */


function generateCustomFilterDropdown(propertyName, entityName, operator, onOperatorChange, value, onValueChange, customFilterRefCallback) {
  return function (props) {
    return React__default.createElement(dataTableCustomFilter, {
      entityName: entityName,
      entityProperty: propertyName,
      filterProps: props,
      operator: operator,
      onOperatorChange: onOperatorChange,
      value: value,
      onValueChange: onValueChange,
      ref: customFilterRefCallback
    });
  };
}
/**
 * Generates a table cell that can be different depending on property type. See `DataTableCell` for details.
 *
 * @param propertyInfo
 * @param text
 * @param mainStore
 */


function renderCell(propertyInfo, text, mainStore) {
  return DataTableCell({
    text: text,
    propertyInfo: propertyInfo,
    mainStore: mainStore
  });
}
/**
 * Sets filters on provided `dataCollection` based on current state of table filters
 *
 * @param tableFilters
 * @param fields
 * @param mainStore
 * @param dataCollection
 */


function setFilters(tableFilters, fields, mainStore, dataCollection) {
  var entityFilter = undefined;

  if (dataCollection.filter && dataCollection.filter.conditions && dataCollection.filter.conditions.length > 0) {
    var preservedConditions = dataCollection.filter.conditions.filter(function (condition) {
      return isPreservedCondition(condition, fields);
    });

    if (preservedConditions.length > 0) {
      entityFilter = {
        conditions: preservedConditions
      };
    }
  }

  if (tableFilters) {
    fields.forEach(function (propertyName) {
      if (tableFilters.hasOwnProperty(propertyName) && tableFilters[propertyName] && tableFilters[propertyName].length > 0) {
        if (!entityFilter) {
          entityFilter = {
            conditions: []
          };
        }

        if (getPropertyInfoNN(propertyName, dataCollection.entityName, mainStore.metadata).attributeType === 'ENUM') {
          // @ts-ignore // TODO fix cuba-react typing
          entityFilter.conditions.push({
            property: propertyName,
            operator: 'in',
            value: tableFilters[propertyName]
          });
        } else {
          var _JSON$parse = JSON.parse(tableFilters[propertyName][0]),
              operator = _JSON$parse.operator,
              value = _JSON$parse.value;

          if (operator === 'inInterval') {
            var minDate = value.minDate,
                maxDate = value.maxDate;
            entityFilter.conditions.push({
              property: propertyName,
              operator: '>=',
              value: minDate
            });
            entityFilter.conditions.push({
              property: propertyName,
              operator: '<=',
              value: maxDate
            });
          } else {
            entityFilter.conditions.push({
              property: propertyName,
              operator: operator,
              value: value
            });
          }
        }
      }
    });
  }

  dataCollection.filter = entityFilter;
}
/**
 * Sets sort field/order on provided `dataCollection` based on current state of table `sorter`
 *
 * @param sorter
 * @param defaultSort name of the field to be sorted by. If the name is preceeding by the '+' character, then the sort order is ascending,
 * if by the '-' character then descending. If there is no special character before the property name, then ascending sort will be used.
 * @param dataCollection
 */


function setSorter(sorter, defaultSort, dataCollection) {
  if (sorter && sorter.order) {
    var sortOrderPrefix = sorter.order === 'descend' ? '-' : '+';
    var sortField;

    if (sorter.field.endsWith('._instanceName')) {
      sortField = sorter.field.substring(0, sorter.field.indexOf('.'));
    } else {
      sortField = sorter.field;
    }

    dataCollection.sort = sortOrderPrefix + sortField;
  } else {
    dataCollection.sort = defaultSort;
  }
}
/**
 *
 * @param pagination
 * @param dataCollection
 */


function setPagination(pagination, dataCollection) {
  if (pagination && pagination.pageSize && pagination.current) {
    dataCollection.limit = pagination.pageSize;
    dataCollection.offset = pagination.pageSize * (pagination.current - 1);
  }
}
/**
 * When called from `Table`'s `onChange` callback this function will reload data collection taking into account antd `Table`'s filters, sorter and pagination
 *
 * @param tableChangeDTO
 */


function handleTableChange(tableChangeDTO) {
  var pagination = tableChangeDTO.pagination,
      filters = tableChangeDTO.filters,
      sorter = tableChangeDTO.sorter,
      defaultSort = tableChangeDTO.defaultSort,
      fields = tableChangeDTO.fields,
      mainStore = tableChangeDTO.mainStore,
      dataCollection = tableChangeDTO.dataCollection;
  setFilters(filters, fields, mainStore, dataCollection);
  setSorter(sorter, defaultSort, dataCollection);
  setPagination(pagination, dataCollection);
  dataCollection.load();
}
/**
 * Converts EntityFilter to antd table filters object.
 * Useful e.g. to set the initial state of table filters when the table is loaded with a predefined EntityFilter.
 *
 * @param entityFilter
 * @param fields allows to check the `entityFilter.conditions` against the list of displayed fields and ensure that only
 * the conditions related to the displayed fields are included in the result
 */


function entityFilterToTableFilters(entityFilter, fields) {
  var tableFilters = {};
  entityFilter.conditions.forEach(function (condition) {
    if (isConditionsGroup(condition)) {
      // ConditionsGroup cannot be represented in / changed via the table UI
      return;
    }

    condition = condition; // TODO @deprecated We might want to make `fields` parameter mandatory in the next major version

    if (!fields || fields.indexOf(condition.property)) {
      tableFilters[condition.property] = [JSON.stringify({
        operator: condition.operator,
        value: condition.value
      })];
    }
  });
  return tableFilters;
}

function isConditionsGroup(conditionOrConditionsGroup) {
  return 'conditions' in conditionOrConditionsGroup;
}
/**
 * Determines whether a condition shall be preserved in `DataCollectionStore` when clearing table filters.
 *
 * @remarks
 * Preserved conditions include `ConditionGroup`s and conditions on fields that are not displayed in the table.
 * Effectively they act as invisible filters that cannot be disabled.
 *
 * @param condition
 * @param fields
 */


function isPreservedCondition(condition, fields) {
  return isConditionsGroup(condition) || fields.indexOf(condition.property) === -1;
}

function isPropertyTypeSupported(propertyInfo) {
  var supportedAttributeTypes = ['ENUM', 'ASSOCIATION', 'COMPOSITION'];
  var supportedTypes = ['string', 'int', 'double', 'decimal', 'date', 'time', 'dateTime', 'boolean'];
  return supportedAttributeTypes.indexOf(propertyInfo.attributeType) > -1 || supportedTypes.indexOf(propertyInfo.type) > -1;
}
/**
 * To be used in (supposedly) unreachable code after exhaustive check of `argument`.
 *
 * @remarks
 * Will cause a compile-time error if `argument` was not exhaustively checked.
 * Will cause a runtime error if reached.
 *
 * @param argumentName
 * @param argument
 */


function assertNever(argumentName, argument) {
  throw new Error("Unexpected ".concat(argumentName, ": ").concat(argument));
}
/**
 * Clears errors in antd form fields
 *
 * @param form
 */


function clearFieldErrors(form) {
  var currentValues = form.getFieldsValue();
  var fields = {};
  Object.keys(currentValues).forEach(function (fieldName) {
    var value = currentValues[fieldName];
    fields[fieldName] = {
      value: value
    };
  });
  form.setFields(fields);
}
/**
 * Extracts validation errors info from server response
 *
 * @param response
 */


function extractServerValidationErrors(response) {
  var fieldErrors = new Map();
  var globalErrors = [];

  if (response instanceof Array) {
    response.forEach(function (error) {
      if (error.message) {
        var fieldName = error.path;

        if (fieldName && fieldName.length > 0) {
          if (fieldErrors.has(fieldName)) {
            fieldErrors.get(fieldName).push(error.message);
          } else {
            fieldErrors.set(fieldName, [error.message]);
          }
        } else {
          globalErrors.push(error.message);
        }
      }
    });
  }

  return {
    globalErrors: globalErrors,
    fieldErrors: fieldErrors
  };
}
/**
 * Constructs antd form fields object containing given errors
 *
 * @param fieldErrors
 * @param form
 */


function constructFieldsWithErrors(fieldErrors, form) {
  var fields = {};
  fieldErrors.forEach(function (errorMessages, fieldName) {
    var combinedErrorMessages = errorMessages.reduce(function (accumulator, current) {
      return "".concat(accumulator, ", ").concat(current);
    });
    fields[fieldName] = {
      value: form.getFieldValue(fieldName),
      errors: [new Error(combinedErrorMessages)]
    };
  });
  return fields;
}

var __decorate$a = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var DataTable =
/*#__PURE__*/
function (_React__default$Compo3) {
  _inherits(DataTable, _React__default$Compo3);

  function DataTable(props) {
    var _this30;

    _classCallCheck(this, DataTable);

    _this30 = _possibleConstructorReturn(this, _getPrototypeOf(DataTable).call(this, props));
    _this30.selectedRowKeys = [];
    _this30.tableFilters = {};
    _this30.operatorsByProperty = new Map();
    _this30.valuesByProperty = new Map();
    _this30.disposers = [];
    _this30.firstLoad = true;
    _this30.customFilters = new Map();

    _this30.onRowSelectionChange = function () {
      switch (_this30.props.rowSelectionMode) {
        case undefined:
          throw new Error("rowSelectionMode is not expected to be ".concat(_this30.props.rowSelectionMode, " at this point"));

        case 'none':
          return;

        case 'multi':
        case 'single':
          if (_this30.props.onRowSelectionChange) {
            _this30.props.onRowSelectionChange(_this30.selectedRowKeys);
          }

          break;

        default:
          assertNever('rowSelectionMode', _this30.props.rowSelectionMode);
      }
    };

    _this30.handleFilterOperatorChange = function (operator, propertyName) {
      _this30.operatorsByProperty.set(propertyName, operator);
    };

    _this30.handleFilterValueChange = function (value, propertyName) {
      _this30.valuesByProperty.set(propertyName, value);
    };

    _this30.onChange = function (pagination, tableFilters, sorter) {
      _this30.tableFilters = tableFilters;
      handleTableChange({
        pagination: pagination,
        filters: tableFilters,
        sorter: sorter,
        defaultSort: _this30.defaultSort,
        fields: _this30.props.fields,
        mainStore: _this30.props.mainStore,
        dataCollection: _this30.props.dataCollection
      });
    };

    _this30.onRowClicked = function (record) {
      if (_this30.isRowSelectionEnabled()) {
        var clickedRowKey = _this30.constructRowKey(record);

        var newSelectedRowKeys = _this30.selectedRowKeys.slice();

        switch (_this30.props.rowSelectionMode) {
          case 'multi':
            var clickedRowKeyIndex = _this30.selectedRowKeys.indexOf(clickedRowKey);

            if (clickedRowKeyIndex > -1) {
              // Deselect row in 'multi' mode
              newSelectedRowKeys.splice(clickedRowKeyIndex, 1);
            } else {
              // Select row in 'multi' mode
              newSelectedRowKeys.push(clickedRowKey);
            }

            break;

          case 'single':
            if (_this30.selectedRowKeys.length > 0 && _this30.selectedRowKeys[0] === clickedRowKey) {
              // Deselect row in 'single' mode
              newSelectedRowKeys = [];
            } else {
              // Select row in 'single' mode
              newSelectedRowKeys[0] = clickedRowKey;
            }

            break;
        }

        _this30.selectedRowKeys = newSelectedRowKeys;
      }
    };

    _this30.onRowSelectionColumnClicked = function (selectedRowKeys) {
      if (_this30.isRowSelectionEnabled()) {
        _this30.selectedRowKeys = selectedRowKeys;
      }
    };

    _this30.onRow = function (record) {
      return {
        onClick: function onClick() {
          _this30.onRowClicked(record);
        }
      };
    };

    _this30.clearFilters = function () {
      _this30.tableFilters = {};

      _this30.operatorsByProperty.clear();

      _this30.valuesByProperty.clear();

      _this30.props.fields.forEach(function (field) {
        var propertyInfo = getPropertyInfoNN(field, _this30.props.dataCollection.entityName, _this30.props.mainStore.metadata);

        if (propertyInfo.type === 'boolean') {
          _this30.valuesByProperty.set(field, 'true');
        }
      });

      _this30.customFilters.forEach(function (customFilter) {
        // @ts-ignore
        customFilter.resetFields(); // Reset Ant Form in CustomFilter
      });

      if (_this30.props.dataCollection.filter) {
        var preservedConditions = _this30.props.dataCollection.filter.conditions.filter(function (condition) {
          return isPreservedCondition(condition, _this30.props.fields);
        });

        if (preservedConditions.length > 0) {
          _this30.props.dataCollection.filter.conditions = preservedConditions;
        } else {
          _this30.props.dataCollection.filter = undefined;
        }
      }

      _this30.props.dataCollection.load();
    };

    if (_this30.props.dataCollection.filter) {
      _this30.tableFilters = entityFilterToTableFilters(_this30.props.dataCollection.filter, _this30.props.fields);
    }

    _this30.defaultSort = _this30.props.dataCollection.sort;
    return _this30;
  }

  _createClass(DataTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this31 = this;

      // When dataCollection.items has changed (e.g. due to sorting, filtering or pagination change) some of the selected rows
      // may not be displayed anymore and shall be removed from selectedRowKeys
      this.disposers.push(reaction(function () {
        return _this31.props.dataCollection.items;
      }, function () {
        if (_this31.isRowSelectionEnabled() && _this31.selectedRowKeys.length > 0 && _this31.props.dataCollection.status === 'DONE') {
          var displayedRowKeys = _this31.props.dataCollection.items.map(function (item) {
            return _this31.constructRowKey(item);
          });

          var displayedSelectedKeys = [];

          _this31.selectedRowKeys.forEach(function (selectedKey) {
            if (displayedRowKeys.indexOf(selectedKey) > -1) {
              displayedSelectedKeys.push(selectedKey);
            }
          });

          _this31.selectedRowKeys = displayedSelectedKeys;
        }
      })); // Call corresponding callback(s) when selectedRowKeys is changed

      this.disposers.push(reaction(function () {
        return _this31.selectedRowKeys;
      }, this.onRowSelectionChange)); // Clear row selection when rowSelectionMode is changed

      this.disposers.push(reaction(function () {
        return _this31.props.rowSelectionMode;
      }, function () {
        _this31.selectedRowKeys = [];
      }));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.disposers.forEach(function (dispose) {
        return dispose();
      });
    }
  }, {
    key: "isRowSelectionEnabled",
    value: function isRowSelectionEnabled() {
      if (this.props.rowSelectionMode) {
        return ['single', 'multi'].indexOf(this.props.rowSelectionMode) > -1;
      } else {
        throw new Error("rowSelectionMode is expected to be defined at this point");
      }
    }
  }, {
    key: "rowSelectionType",
    value: function rowSelectionType() {
      switch (this.props.rowSelectionMode) {
        case 'multi':
          return 'checkbox';

        case 'single':
          return 'radio';

        default:
          throw new Error("rowSelectionMode is not expected to be ".concat(this.props.rowSelectionMode, " at this point"));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this32 = this;

      var _this$props$dataColle = this.props.dataCollection,
          items = _this$props$dataColle.items,
          status = _this$props$dataColle.status;
      var isMainStoreAvailable = !!this.props.mainStore && !!this.props.mainStore.messages && !!this.props.mainStore.metadata && !!this.props.mainStore.enums;

      if (!isMainStoreAvailable || status === "LOADING" && this.firstLoad) {
        return React__default.createElement("div", {
          className: 'cuba-data-table-loader'
        }, React__default.createElement(Spin, {
          size: 'large'
        }));
      }

      this.firstLoad = false;
      var defaultTableProps = {
        bodyStyle: {
          overflowX: 'auto'
        },
        loading: status === 'LOADING',
        columns: this.generateColumnProps,
        dataSource: items.slice(),
        onChange: this.onChange,
        pagination: this.paginationConfig,
        rowKey: function rowKey(record) {
          return _this32.constructRowKey(record);
        }
      };

      if (this.isRowSelectionEnabled()) {
        defaultTableProps = Object.assign({}, defaultTableProps, {
          rowSelection: {
            type: this.rowSelectionType(),
            selectedRowKeys: toJS(this.selectedRowKeys),
            onChange: this.onRowSelectionColumnClicked
          }
        });

        if (this.props.canSelectRowByClick) {
          defaultTableProps = Object.assign({}, defaultTableProps, {
            onRow: this.onRow
          });
        }
      }

      var tableProps = Object.assign({}, defaultTableProps, this.props.tableProps);
      return React__default.createElement("div", {
        className: 'cuba-data-table'
      }, React__default.createElement("div", {
        className: 'buttons'
      }, this.props.buttons, this.props.hideClearFilters ? null : this.clearFiltersButton), React__default.createElement(Table, Object.assign({}, tableProps, {
        className: this.props.hideSelectionColumn ? '_cuba-hide-selection-column' : ''
      })));
    }
  }, {
    key: "isClearFiltersShown",
    value: function isClearFiltersShown() {
      var _this33 = this;

      return this.props.dataCollection.filter != null && this.props.dataCollection.filter.conditions != null && this.props.dataCollection.filter.conditions.some(function (condition) {
        return !isPreservedCondition(condition, _this33.props.fields);
      });
    }
  }, {
    key: "enableFilterForColumn",
    value: function enableFilterForColumn(propertyName) {
      return this.props.enableFiltersOnColumns ? this.props.enableFiltersOnColumns.indexOf(propertyName) > -1 : true;
    }
  }, {
    key: "constructRowKey",
    value: function constructRowKey(record) {
      return record.id;
    }
  }, {
    key: "paginationConfig",
    get: function get() {
      return {
        showSizeChanger: true,
        total: this.props.dataCollection.count
      };
    }
  }, {
    key: "clearFiltersButton",
    get: function get() {
      if (this.isClearFiltersShown()) {
        return React__default.createElement(Button, {
          htmlType: 'button',
          className: 'cuba-data-table-clear-filters',
          onClick: this.clearFilters,
          type: 'link'
        }, React__default.createElement(Icon, {
          type: 'filter'
        }), React__default.createElement("span", null, React__default.createElement(FormattedMessage, {
          id: 'cubaReact.dataTable.clearAllFilters'
        })));
      } else {
        return null;
      }
    }
  }, {
    key: "generateColumnProps",
    get: function get() {
      var _this34 = this;

      return this.props.fields.map(function (property) {
        var generatedColumnProps = generateDataColumn({
          propertyName: property,
          entityName: _this34.props.dataCollection.entityName,
          enableFilter: _this34.enableFilterForColumn(property),
          filters: _this34.tableFilters,
          operator: _this34.operatorsByProperty.get(property),
          onOperatorChange: _this34.handleFilterOperatorChange,
          value: _this34.valuesByProperty.get(property),
          onValueChange: _this34.handleFilterValueChange,
          enableSorter: true,
          mainStore: _this34.props.mainStore,
          customFilterRef: function customFilterRef(instance) {
            return _this34.customFilters.set(property, instance);
          }
        });
        return Object.assign({}, generatedColumnProps, _this34.props.columnProps);
      });
    }
  }]);

  return DataTable;
}(React__default.Component);

DataTable.defaultProps = {
  rowSelectionMode: 'single',
  canSelectRowByClick: true,
  hideSelectionColumn: false,
  hideClearFilters: false
};

__decorate$a([observable], DataTable.prototype, "selectedRowKeys", void 0);

__decorate$a([observable.ref], DataTable.prototype, "tableFilters", void 0);

__decorate$a([observable], DataTable.prototype, "operatorsByProperty", void 0);

__decorate$a([observable], DataTable.prototype, "valuesByProperty", void 0);

__decorate$a([computed], DataTable.prototype, "paginationConfig", null);

__decorate$a([action], DataTable.prototype, "handleFilterOperatorChange", void 0);

__decorate$a([action], DataTable.prototype, "handleFilterValueChange", void 0);

__decorate$a([action], DataTable.prototype, "onChange", void 0);

__decorate$a([action], DataTable.prototype, "onRowClicked", void 0);

__decorate$a([action], DataTable.prototype, "onRowSelectionColumnClicked", void 0);

__decorate$a([action], DataTable.prototype, "onRow", void 0);

__decorate$a([action], DataTable.prototype, "clearFilters", void 0);

__decorate$a([computed], DataTable.prototype, "clearFiltersButton", null);

__decorate$a([computed], DataTable.prototype, "generateColumnProps", null);

DataTable = __decorate$a([injectMainStore, observer], DataTable);

function MultilineText(_ref11) {
  var lines = _ref11.lines;
  return createElement(Fragment, null, lines.map(function (line, index) {
    return createElement("div", {
      key: index
    }, line);
  }));
}

function withLocalizedForm(options) {
  return function (Component) {
    return function (props) {
      var ComponentWithForm = Form.create(Object.assign({
        validateMessages: createAntdFormValidationMessages(props.intl)
      }, options))(Component);
      return createElement(ComponentWithForm, Object.assign({}, props));
    };
  };
}

function createAntdFormValidationMessages(intl) {
  return {
    default: intl.formatMessage({
      id: 'antd.form.validation.default'
    }),
    required: intl.formatMessage({
      id: 'antd.form.validation.required'
    }),
    enum: intl.formatMessage({
      id: 'antd.form.validation.enum'
    }),
    whitespace: intl.formatMessage({
      id: 'antd.form.validation.whitespace'
    }),
    date: {
      format: intl.formatMessage({
        id: 'antd.form.validation.date.format'
      }),
      parse: intl.formatMessage({
        id: 'antd.form.validation.date.parse'
      }),
      invalid: intl.formatMessage({
        id: 'antd.form.validation.date.invalid'
      })
    },
    types: {
      string: intl.formatMessage({
        id: 'antd.form.validation.types.string'
      }),
      method: intl.formatMessage({
        id: 'antd.form.validation.types.method'
      }),
      array: intl.formatMessage({
        id: 'antd.form.validation.types.array'
      }),
      object: intl.formatMessage({
        id: 'antd.form.validation.types.object'
      }),
      number: intl.formatMessage({
        id: 'antd.form.validation.types.number'
      }),
      date: intl.formatMessage({
        id: 'antd.form.validation.types.date'
      }),
      boolean: intl.formatMessage({
        id: 'antd.form.validation.types.boolean'
      }),
      integer: intl.formatMessage({
        id: 'antd.form.validation.types.integer'
      }),
      float: intl.formatMessage({
        id: 'antd.form.validation.types.float'
      }),
      regexp: intl.formatMessage({
        id: 'antd.form.validation.types.regexp'
      }),
      email: intl.formatMessage({
        id: 'antd.form.validation.types.email'
      }),
      url: intl.formatMessage({
        id: 'antd.form.validation.types.url'
      }),
      hex: intl.formatMessage({
        id: 'antd.form.validation.types.hex'
      })
    },
    string: {
      len: intl.formatMessage({
        id: 'antd.form.validation.string.len'
      }),
      min: intl.formatMessage({
        id: 'antd.form.validation.string.min'
      }),
      max: intl.formatMessage({
        id: 'antd.form.validation.string.max'
      }),
      range: intl.formatMessage({
        id: 'antd.form.validation.string.range'
      })
    },
    number: {
      len: intl.formatMessage({
        id: 'antd.form.validation.number.len'
      }),
      min: intl.formatMessage({
        id: 'antd.form.validation.number.min'
      }),
      max: intl.formatMessage({
        id: 'antd.form.validation.number.max'
      }),
      range: intl.formatMessage({
        id: 'antd.form.validation.number.range'
      })
    },
    array: {
      len: intl.formatMessage({
        id: 'antd.form.validation.array.len'
      }),
      min: intl.formatMessage({
        id: 'antd.form.validation.array.min'
      }),
      max: intl.formatMessage({
        id: 'antd.form.validation.array.max'
      }),
      range: intl.formatMessage({
        id: 'antd.form.validation.array.range'
      })
    },
    pattern: {
      mismatch: intl.formatMessage({
        id: 'antd.form.validation.pattern.mismatch'
      })
    }
  };
}

export { Collection, CubaAppProvider, DataCollectionStore, DataInstanceStore, DataTable, dataTableCustomFilter as DataTableCustomFilter, EntityProperty, EnumField, Field, fileUpload as FileUpload, FormField, I18nProvider, Instance, MainStore, Msg, MultilineText, assertNever, clearFieldErrors, collection, constructFieldsWithErrors, createAntdFormValidationMessages, data, defaultOpts, entityFilterToTableFilters, extractServerValidationErrors, generateCustomFilterDropdown, generateDataColumn, generateEnumFilter, getCubaREST, getEnumCaption, getMainStore, getMenuItems, getPropertyCaption, getPropertyInfo, getPropertyInfoNN, handleTableChange, injectMainStore, instance, isConditionsGroup, isDateProperty, isDateTimeProperty, isFileProperty, isPreservedCondition, isPropertyTypeSupported, isRelationProperty, isTimeProperty, isToManyRelation, isToOneRelation, renderCell, setFilters, setPagination, setSorter, withDataCollection, withDataInstance, withLocalizedForm };